import React, { useEffect, useState, useRef } from "react";
import {
  DateInput,
  RadioInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs/index.js";
import Button from "../../components/common/ui/Button.jsx";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { history } from "../../_helpers/index.js";
import { useDispatch, useSelector } from "react-redux";
import { masterActions, authActions } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import { StoredProcedures } from "../../_helpers/enumerator";
import {
  publicUserActions,
  revenueReportingActions,
} from "../../_store/index.js";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import RevenueReportTable from "./RevenueReportTable.jsx";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal.js";
import generatePDFForVerticalTable from "../../components/common/export/generateRevenuePDF.jsx";
import { Popup } from "../../components/common/ui/NotificationModal/Popup.js";
import revenueReportSchema from "../../validation/revenueReportSchema.js";
import { fDate, MinDate, Today } from "./../../utils/formatTime";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoredValue } from "../../_helpers/storagehelper.js";

function RevenueReport() {
  // const facilityDropDown = useSelector(
  //   (state) => state.master?.facilityDropDown
  // );
  const wasMonthResetByYear = useRef(false);
  const wasMonthTouched = useRef(false);

  const { facilityDropDown: facilitydata } = useSelector(
    (state) => state.master
  );

  const location = useLocation();
  const navigate = useNavigate();
  const {
    revenueSummaryList,
    userPaymentInfo,
    inmateFN,
    inmateLN,
    POTransStatusUpdate,
    POTpaymentUpdate,
    loading,
    reports,
    records,
    actions,
    monthNames,
    paymentTypeOption,
    isPageScroll
  } = useSelector((state) => state.revenueReporting);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);
  const [showSearchFields, setShowSearchFields] = useState(true);
  const [showCactasSearchFields, setShowCactasSearchFields] = useState(false);

  const [errorMessage, setErrorMessage] = useState({});
  const [resetFlag, setResetFlag] = useState(false);

  const [tableColumn, setTableColumn] = useState();
  const [tableTitle, setTableTitle] = useState();
  const [tableTotalRecord, setTableTotalRecord] = useState();
  // Mobile View facilityId is not being set.
  const [facilityId, setFacilityId] = useState(0);
  const [tableData, setTableData] = useState();
  const [tableShow, setTableShow] = useState(false);
  const [currentShowingTable, setCurrentShowingTable] = useState("");
  // POTransactionRandomID state
  const [pOTransactionRandomID, setPOTransactionRandomID] = useState(0);
  const [touchedFields, setTouchedFields] = useState({});
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const dispatch = useDispatch();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const loggedUser = getStoredValue("user")?.ManagementUserID;
  const Payment_Approvers = JSON.parse(process.env.REACT_APP_PAYMENT_APPROVERS || "[]");


  // Reset the radio button.Due to reset issue for this code
  useEffect(() => {
    if (resetFlag) {
      dispatch(
        revenueReportingActions.setReports({
          ...reports,
          actions: 2,
          records: 1,
        })
      );
      setResetFlag(false);
    }
  }, [resetFlag]);

  // Mobile view facilityId is not being set..
  useEffect(() => {
    dispatch(
      revenueReportingActions.setReports({
        ...reports,
        facilityId: facilityId,
      })
    );
    handleOnBlur({ target: { name: "facilityId" } });
  }, [facilityId]);

  useEffect(() => {
    if (reports?.facilityId) handleSearch();
  }, [reports?.facilityId]);

  // IOS Dropdown onchange and onblur Validation message issue.
  useEffect(() => {
    if (touchedFields.year) {
      handleOnBlur({ target: { name: "year" } });
    }
  }, [reports?.year]);

  useEffect(() => {
    if (touchedFields.month) {
      handleOnBlur({ target: { name: "month" } });
    }
  }, [reports?.month]);

  useEffect(() => {
    // Check if the required conditions are met
    if (
      inmateLN?.length > 0 &&
      reports?.lastName !== "" &&
      reports?.lastNameValue !== 0
    ) {
      const selectedItem = inmateLN?.find(
        (item) => item.label === reports?.lastName
      );

      if (
        selectedItem &&
        selectedItem.label === reports?.lastName &&
        selectedItem.value !== reports?.lastNameValue
      ) {
        // Dispatch action if all conditions are met
        dispatch(
          revenueReportingActions.setReports({
            ...reports,
            lastNameValue: selectedItem.value,
          })
        );
      }
    }
  }, [reports?.lastNameValue, inmateLN]); // Dependencies: trigger when reports.lastNameValue or inmateLN changes

  useEffect(() => {
    // Check if the required conditions are met
    if (
      inmateFN?.length > 0 &&
      reports?.firstName !== "" &&
      reports?.firstNameValue !== 0
    ) {
      const selectedItem = inmateFN?.find(
        (item) => item.label === reports?.firstName
      );

      if (
        selectedItem &&
        selectedItem.label === reports?.firstName &&
        selectedItem.value !== reports?.firstNameValue
      ) {
        // Dispatch action if all conditions are met
        dispatch(
          revenueReportingActions.setReports({
            ...reports,
            firstNameValue: selectedItem.value,
          })
        );
      }
    }
  }, [reports?.firstNameValue, inmateFN]); // Dependencies: trigger when reports.firstNameValue or inmateFN changes

  // Back to load search
  useEffect(() => {
    if (location.state?.currentShowingTable !== "") {
      navigate(location.pathname, {
        state: {
          ...location.state,
          currentShowingTable: "",
        },
      });
      setCurrentShowingTable(location.state?.currentShowingTable);
      const sortBy = reports?.sortBy;
      switch (location.state?.currentShowingTable) {
        case "PurchasedCreditsMonthly":
          let purchasedMonthlyValue = {
            facilityID: reports?.facilityId,
            paymentType:
              reports?.paymentType === "ALL" ? "" : reports?.paymentType,
            month: reports?.actions === 3 ? 0 : reports?.month,
            year: reports?.actions === 3 ? 0 : reports?.year,
            transactionSucess: 1,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
            toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            sortBy: sortBy,
          };
          dispatch(
            revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
              purchasedMonthlyValue
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(purchaseCreditColumns);
            setTableTitle("PURCHASED CREDITS");
          });
          break;
        case "PurchasedCreditsDaily":
          let purchasedDailyValue = {
            facilityId: reports?.facilityId,
            paymentType:
              reports?.paymentType === "ALL" ? "" : reports?.paymentType,
            dobEndDate: fDate(reports?.dobEndDate),
            transactionSucess: 1,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            sortBy: sortBy,
          };
          dispatch(
            revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
              purchasedDailyValue
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableData(result?.DataList);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableColumn(purchaseCreditColumns);
            setTableTitle("PURCHASED CREDITS");
          });
          break;
        case "FailedTransactionsMonthly":
          let failedmonthlyvalue = {
            facilityID: reports?.facilityId,
            paymentType:
              reports?.paymentType === "ALL" ? "" : reports?.paymentType,
            month: reports?.actions === 3 ? 0 : reports?.month,
            year: reports?.actions === 3 ? 0 : reports?.year,
            transactionSucess: -1,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
            toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            sortBy: sortBy,
          };
          dispatch(
            revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
              failedmonthlyvalue
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(failedTransactionColumns);
            setTableTitle("FAILED TRANSACTIONS");
          });
          break;
        case "FailedTransactionsDaily":
          let faileddailyvalue = {
            facilityId: reports?.facilityId,
            paymentType:
              reports?.paymentType === "ALL" ? "" : reports?.paymentType,
            dobEndDate: fDate(reports?.dobEndDate),
            transactionSucess: -1,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            sortBy: sortBy,
          };
          dispatch(
            revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
              faileddailyvalue
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(failedTransactionColumns);
            setTableTitle("FAILED TRANSACTIONS");
          });
          break;
        case "PendingTransactionsMonthly":
          let pendingmonthlyvalue = {
            facilityID: reports?.facilityId,
            paymentType:
              reports?.paymentType === "ALL" ? "" : reports?.paymentType,
            month: reports?.actions === 3 ? 0 : reports?.month,
            year: reports?.actions === 3 ? 0 : reports?.year,
            transactionSucess: 0,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
            toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            sortBy: sortBy,
          };
          dispatch(
            revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
              pendingmonthlyvalue
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(pendingTransactionColumns);
            setTableTitle("PENDING TRANSACTIONS");
          });
          break;
        case "PendingTransactionsDaily":
          let pendingDailytrans = {
            facilityId: reports?.facilityId,
            paymentType:
              reports?.paymentType === "ALL" ? "" : reports?.paymentType,
            dobEndDate: fDate(reports?.dobEndDate),
            transactionSucess: 0,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            sortBy: sortBy,
          };
          dispatch(
            revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
              pendingDailytrans
            )
          ).then((res) => {
            let result = res?.payload;
            //dispatch(revenueReportingActions.setdailyPOtransaction(result));
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(pendingTransactionColumns);
            setTableTitle("PENDING TRANSACTIONS");
          });
          break;
        case "FreeCreditsMonthly":
          let freeCreditsMonthly = {
            facilityID: reports?.facilityId,
            month: reports?.actions === 3 ? 0 : reports?.month,
            year: reports?.actions === 3 ? 0 : reports?.year,
            sortBy: sortBy,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
            toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          };
          dispatch(
            revenueReportingActions.LoadMonthlyFreeCreditsList(
              freeCreditsMonthly
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(freeCreditColumns);
            setTableTitle("FREE CREDITS");
          });
          break;
        case "FreeCreditsDaily":
          let freecreditDailytrans = {
            facilityId: reports?.facilityId,
            selectDate: fDate(reports?.dobEndDate),
            sortBy: sortBy,
            pageNo: 1,
            rowCountPerPage: reports?.rowCountPerPage,
          };
          dispatch(
            revenueReportingActions.LoadDailyFreeCreditsList(
              freecreditDailytrans
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(freeCreditColumns);
            setTableTitle("FREE CREDITS");
          });
          break;
        case "CactasCreditsMonthly":
          let CactasCreditsmonthly = {
            facilityID: reports?.facilityId,
            month: reports?.actions === 3 ? 0 : reports?.month,
            year: reports?.actions === 3 ? 0 : reports?.year,
            sortBy: sortBy,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
            toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          };
          dispatch(
            revenueReportingActions.LoadMonthlyCactasCreditsList(
              CactasCreditsmonthly
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(CactasCreditsColumns);
            setTableTitle("CACTAS CREDITS");
          });
          break;
        case "CactasCreditsDaily":
          let cactasCreditsDaily = {
            facilityId: reports?.facilityId,
            selectDate: fDate(reports?.dobEndDate),
            sortBy: sortBy,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
          };
          dispatch(
            revenueReportingActions.LoadDailyCactasCreditsList(
              cactasCreditsDaily
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(CactasCreditsColumns);
            setTableTitle("CACTAS CREDITS");
          });
          break;
        case "CactasRefund":
          let cactasRefund = {
            facilityID: reports?.facilityId,
            inmateResidentID: "",
            firstName: "",
            lastName: "",
            taskNo: 0,
            refundTaskNo: 0,
            month: reports?.actions === 3 ? 0 : reports?.month,
            year: reports?.actions === 3 ? 0 : reports?.year,
            sortBy: sortBy,
            pageNo: reports?.pageNo,
            rowCountPerPage: reports?.rowCountPerPage,
            fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
            toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          };
          dispatch(
            revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(
              cactasRefund
            )
          ).then((res) => {
            let result = res?.payload;
            setTableShow(true);
            setTableTotalRecord(result?.TotalRecordCount);
            setTableData(result?.DataList);
            setTableColumn(CactasRefundColumns);
            setTableTitle("CACTAS REFUND");
          });
          break;
        default:
          break;
      }
    }
  }, [location.state?.currentShowingTable]);

  useEffect(() => {
    switch (POTpaymentUpdate?.IsSucceed) {
      case 0:
        switch (currentShowingTable) {
          case "FailedTransactionsMonthly":
            let failedmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                failedmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;

          case "FailedTransactionsDaily":
            let faileddailyvalue = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                faileddailyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;

          case "PendingTransactionsMonthly":
            let pendingmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                pendingmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              if (result?.DataList?.length === 0) {
                const searchParams = {
                  facilityID: reports?.facilityId,
                  paymentType:
                    reports?.paymentType === "ALL" ? "" : reports?.paymentType,
                  month: reports?.actions === 3 ? 0 : reports?.month,
                  year: reports?.actions === 3 ? 0 : reports?.year,
                  transactionSucess: 0,
                  pageNo: 1,
                  sortBy: "PurchaseOrderTransactionID DESC",
                  rowCountPerPage: 10,
                  fromDate:
                    reports?.actions === 2 ? "" : fDate(reports?.fromDate),
                  toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
                };
                dispatch(
                  revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                    searchParams
                  )
                )
                  .then((result) => {
                    const repeatedCallResult = result?.payload;
                    setTableShow(true);
                    setTableTotalRecord(repeatedCallResult?.TotalRecordCount);
                    setTableData(repeatedCallResult.DataList);
                    setTableColumn(pendingTransactionColumns);
                    setTableTitle("PENDING TRANSACTIONS");
                  })
                  .catch((err) => {
                    showToastNotification("Faile to fetch data.", "error");
                  });
                return;
              }
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          case "PendingTransactionsDaily":
            let pendingDailytrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 0,
              pageNo: 1,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: 10,
            };

            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                pendingDailytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              if (result?.DataList?.length === 0) {
                const searchParams = {
                  facilityId: reports?.facilityId,
                  paymentType:
                    reports?.paymentType === "ALL" ? "" : reports?.paymentType,
                  dobEndDate: fDate(reports?.dobEndDate),
                  transactionSucess: 0,
                  pageNo: reports?.pageNo,
                  sortBy: "PurchaseOrderTransactionID DESC",
                  rowCountPerPage: reports?.rowCountPerPage,
                };
                dispatch(
                  revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                    searchParams
                  )
                )
                  .then((result) => {
                    const repeatedCallResult = result?.payload;
                    setTableShow(true);
                    setTableTotalRecord(repeatedCallResult?.TotalRecordCount);
                    setTableData(repeatedCallResult.DataList);
                    setTableColumn(pendingTransactionColumns);
                    setTableTitle("PENDING TRANSACTIONS");
                  })
                  .catch((err) => {
                    showToastNotification("Faile to fetch data.", "error");
                  });
              }
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          default:
            break;
        }
        showToastNotification("Updated Successfully.", "success");
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
            UserAction: `Updated Pending Transaction via Revenue Report Page(POTransactionRandomID - ${pOTransactionRandomID})`,
          })
        );
        dispatch(revenueReportingActions.ClearPOTpaymentUpdate());
        break;

      default:
        break;
    }
  }, [POTpaymentUpdate]);

  useEffect(() => {
    dispatch(revenueReportingActions?.ClearRevenueSummaryList());
  }, []);

  useEffect(() => {
    switch (POTransStatusUpdate?.IsSucceed) {
      case 1:
        switch (currentShowingTable) {
          case "FailedTransactionsMonthly":
            let failedmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              rowCountPerPage: reports?.rowCountPerPage,
              sortBy: "PurchaseOrderTransactionID DESC",
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                failedmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;

              if (result?.DataList?.length === 0) {
                const searchParams = {
                  facilityID: reports?.facilityId,
                  paymentType:
                    reports?.paymentType === "ALL" ? "" : reports?.paymentType,
                  month: reports?.actions === 3 ? 0 : reports?.month,
                  year: reports?.actions === 3 ? 0 : reports?.year,
                  transactionSucess: -1,
                  pageNo: 1,
                  rowCountPerPage: 10,
                  sortBy: "PurchaseOrderTransactionID DESC",
                  fromDate:
                    reports?.actions === 2 ? "" : fDate(reports?.fromDate),
                  toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
                };
                dispatch(
                  revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                    searchParams
                  )
                )
                  .then((result) => {
                    const repeatedCallResult = result?.payload;
                    setTableShow(true);
                    setTableTotalRecord(repeatedCallResult?.TotalRecordCount);
                    setTableData(repeatedCallResult.DataList);
                    setTableColumn(failedTransactionColumns);
                    setTableTitle("FAILED TRANSACTIONS");
                  })
                  .catch((err) => {
                    showToastNotification("Faile to fetch data.", "error");
                  });
              }
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;

          case "FailedTransactionsDaily":
            let faileddailyvalue = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                faileddailyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              if (result?.DataList?.length === 0) {
                const searchParams = {
                  facilityId: reports?.facilityId,
                  paymentType:
                    reports?.paymentType === "ALL" ? "" : reports?.paymentType,
                  dobEndDate: fDate(reports?.dobEndDate),
                  transactionSucess: -1,
                  pageNo: reports?.pageNo,
                  sortBy: "PurchaseOrderTransactionID DESC",
                  rowCountPerPage: reports?.rowCountPerPage,
                };

                dispatch(
                  revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                    searchParams
                  )
                )
                  .then((result) => {
                    const repeatedCallResult = result?.payload;
                    setTableShow(true);
                    setTableTotalRecord(repeatedCallResult?.TotalRecordCount);
                    setTableData(repeatedCallResult.DataList);
                    setTableColumn(failedTransactionColumns);
                    setTableTitle("FAILED TRANSACTIONS");
                  })
                  .catch((err) => {
                    showToastNotification("Faile to fetch data.", "error");
                  });
              }
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;

          case "PendingTransactionsMonthly":
            let pendingmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                pendingmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              if (result?.DataList?.length === 0) {
                const searchParams = {
                  facilityID: reports?.facilityId,
                  paymentType:
                    reports?.paymentType === "ALL" ? "" : reports?.paymentType,
                  month: reports?.actions === 3 ? 0 : reports?.month,
                  year: reports?.actions === 3 ? 0 : reports?.year,
                  transactionSucess: 0,
                  pageNo: 1,
                  sortBy: "PurchaseOrderTransactionID DESC",
                  rowCountPerPage: 10,
                  fromDate:
                    reports?.actions === 2 ? "" : fDate(reports?.fromDate),
                  toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
                };
                dispatch(
                  revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                    searchParams
                  )
                )
                  .then((result) => {
                    const repeatedCallResult = result?.payload;
                    setTableShow(true);
                    setTableTotalRecord(repeatedCallResult?.TotalRecordCount);
                    setTableData(repeatedCallResult.DataList);
                    setTableColumn(pendingTransactionColumns);
                    setTableTitle("PENDING TRANSACTIONS");
                  })
                  .catch((err) => {
                    showToastNotification("Faile to fetch data.", "error");
                  });
                return;
              }
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          case "PendingTransactionsDaily":
            let pendingDailytrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                pendingDailytrans
              )
            ).then((res) => {
              let result = res?.payload;

              if (result?.DataList?.length === 0) {
                const searchParams = {
                  facilityId: reports?.facilityId,
                  paymentType:
                    reports?.paymentType === "ALL" ? "" : reports?.paymentType,
                  dobEndDate: fDate(reports?.dobEndDate),
                  transactionSucess: 0,
                  pageNo: reports?.pageNo,
                  sortBy: "PurchaseOrderTransactionID DESC",
                  rowCountPerPage: reports?.rowCountPerPage,
                };
                dispatch(
                  revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                    searchParams
                  )
                )
                  .then((result) => {
                    const repeatedCallResult = result?.payload;
                    setTableShow(true);
                    setTableTotalRecord(repeatedCallResult?.TotalRecordCount);
                    setTableData(repeatedCallResult.DataList);
                    setTableColumn(pendingTransactionColumns);
                    setTableTitle("PENDING TRANSACTIONS");
                  })
                  .catch((err) => {
                    showToastNotification("Faile to fetch data.", "error");
                  });
                return;
              }
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          default:
            break;
        }
        showToastNotification("Payment Confirmed Successfully.", "success");
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
            UserAction: `Confirmed Payment via Revenue Report Page (POTransactionRandomID - ${pOTransactionRandomID})`,
          })
        );
        dispatch(revenueReportingActions.ClearPOTransStatusUpdate());
        break;
      case -1:
        switch (currentShowingTable) {
          case "FailedTransactionsMonthly":
            let failedmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                failedmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;
          case "FailedTransactionsDaily":
            let faileddailyvalue = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                faileddailyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;
          case "PendingTransactionsMonthly":
            let pendingmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                pendingmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;
          case "PendingTransactionsDaily":
            let pendingDailytrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                pendingDailytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          default:
            break;
        }
        showToastNotification("Payment Operation Failed.", "error");
        dispatch(revenueReportingActions.ClearPOTransStatusUpdate());
        break;
      case -2:
        switch (currentShowingTable) {
          case "FailedTransactionsMonthly":
            let failedmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              rowCountPerPage: reports?.rowCountPerPage,
              sortBy: "PurchaseOrderTransactionID DESC",
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                failedmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;
          case "FailedTransactionsDaily":
            let faileddailyvalue = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                faileddailyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;
          case "PendingTransactionsMonthly":
            let pendingmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              rowCountPerPage: reports?.rowCountPerPage,
              sortBy: "PurchaseOrderTransactionID DESC",
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                pendingmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;
          case "PendingTransactionsDaily":
            let pendingDailytrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                pendingDailytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          default:
            break;
        }
        showToastNotification(" Payment Canceled Successfully.", "success");
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
            UserAction: `Canceled Payment via Revenue Report Page (POTransactionRandomID- ${pOTransactionRandomID})`,
          })
        );
        dispatch(revenueReportingActions.ClearPOTransStatusUpdate());
        break;
      case -3:
        switch (currentShowingTable) {
          case "FailedTransactionsMonthly":
            let failedmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                failedmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;
          case "FailedTransactionsDaily":
            let faileddailyvalue = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: -1,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                faileddailyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(failedTransactionColumns);
              setTableTitle("FAILED TRANSACTIONS");
            });
            break;
          case "PendingTransactionsMonthly":
            let pendingmonthlyvalue = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                pendingmonthlyvalue
              )
            ).then((res) => {
              let result = res?.payload;
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;
          case "PendingTransactionsDaily":
            let pendingDailytrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 0,
              pageNo: reports?.pageNo,
              sortBy: "PurchaseOrderTransactionID DESC",
              rowCountPerPage: reports?.rowCountPerPage,
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                pendingDailytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result.DataList);
              setTableColumn(pendingTransactionColumns);
              setTableTitle("PENDING TRANSACTIONS");
            });
            break;

          default:
            break;
        }
        showToastNotification("Invalid PurchaseOrderTransaction.", "error");
        dispatch(revenueReportingActions.ClearPOTransStatusUpdate());
        break;

      default:
        break;
    }
  }, [POTransStatusUpdate]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);

  useEffect(() => {
    const sortBy = reports?.sortBy;
    switch (currentShowingTable) {
      case "PurchasedCreditsMonthly":
        let purchasedMonthlyValue = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: 1,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          sortBy: sortBy,
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            purchasedMonthlyValue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(purchaseCreditColumns);
          setTableTitle("PURCHASED CREDITS");
        });
        break;
      case "PurchasedCreditsDaily":
        let purchasedDailyValue = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: 1,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          sortBy: sortBy,
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            purchasedDailyValue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableData(result?.DataList);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableColumn(purchaseCreditColumns);
          setTableTitle("PURCHASED CREDITS");
        });
        break;
      case "FailedTransactionsMonthly":
        let failedmonthlyvalue = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: -1,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          sortBy: sortBy,
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            failedmonthlyvalue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(failedTransactionColumns);
          setTableTitle("FAILED TRANSACTIONS");
        });
        break;
      case "FailedTransactionsDaily":
        let faileddailyvalue = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: -1,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          sortBy: sortBy,
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            faileddailyvalue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(failedTransactionColumns);
          setTableTitle("FAILED TRANSACTIONS");
        });
        break;
      case "PendingTransactionsMonthly":
        let pendingmonthlyvalue = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: 0,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          sortBy: sortBy,
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            pendingmonthlyvalue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(pendingTransactionColumns);
          setTableTitle("PENDING TRANSACTIONS");
        });
        break;
      case "PendingTransactionsDaily":
        let pendingDailytrans = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: 0,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          sortBy: sortBy,
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            pendingDailytrans
          )
        ).then((res) => {
          let result = res?.payload;
          //dispatch(revenueReportingActions.setdailyPOtransaction(result));
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(pendingTransactionColumns);
          setTableTitle("PENDING TRANSACTIONS");
        });
        break;
      case "FreeCreditsMonthly":
        let freeCreditsMonthly = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: sortBy,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyFreeCreditsList(freeCreditsMonthly)
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(freeCreditColumns);
          setTableTitle("FREE CREDITS");
        });
        break;
      case "FreeCreditsDaily":
        let freecreditDailytrans = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: sortBy,
          pageNo: 1,
          rowCountPerPage: reports?.rowCountPerPage,
        };
        dispatch(
          revenueReportingActions.LoadDailyFreeCreditsList(freecreditDailytrans)
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(freeCreditColumns);
          setTableTitle("FREE CREDITS");
        });
        break;
      case "CactasCreditsMonthly":
        let CactasCreditsmonthly = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: sortBy,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyCactasCreditsList(
            CactasCreditsmonthly
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(CactasCreditsColumns);
          setTableTitle("CACTAS CREDITS");
        });
        break;
      case "CactasCreditsDaily":
        let cactasCreditsDaily = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: sortBy,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
        };
        dispatch(
          revenueReportingActions.LoadDailyCactasCreditsList(cactasCreditsDaily)
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(CactasCreditsColumns);
          setTableTitle("CACTAS CREDITS");
        });
        break;
      case "CactasRefund":
        let cactasRefund = {
          facilityID: reports?.facilityId,
          inmateResidentID: "",
          firstName: "",
          lastName: "",
          taskNo: 0,
          refundTaskNo: 0,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: sortBy,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(
            cactasRefund
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(CactasRefundColumns);
          setTableTitle("CACTAS REFUND");
        });
        break;
      default:
        break;
    }
  }, [reports?.rowCountPerPage, reports?.pageNo]);
  const handleSelectChange = (event, type) => {
    let updatedReports = { ...reports };
    // iOS fix - sometimes event is undefined

    const value = event?.value ?? (type === "paymentType" ? "ALL" : 0);

    if (type === "month") {
      setTouchedFields((prev) => ({
        ...prev,
        month: true,
      }));
      wasMonthTouched.current = true; // user touched
      wasMonthResetByYear.current = false; // clear skip flag
      updatedReports[type] = value;
      setErrorMessage((prev) => ({
        ...prev,
        month: value != 0 ? "" : "Please select Month.",
      }));
    } else if (type === "year") {
      setTouchedFields((prev) => ({
        ...prev,
        year: true,
      }));
      updatedReports[type] = value;
      setErrorMessage((prev) => ({
        ...prev,
        year: value != 0 ? "" : "Please select Year.",
      }));
      //  updatedReports.month = 0;
      if (reports.month) {
        updatedReports.month = null; // reset month
        wasMonthResetByYear.current = true; // set skip flag
        wasMonthTouched.current = false; // don't validate
      }

      setErrorMessage((prev) => ({
        ...prev,
        month: "",
      }));
    } else if (type === "paymentType") {
      updatedReports[type] = value;
    } else if (type === "facilityId") {
      setFacilityId(event?.value ?? 0);
      updatedReports[type] = event?.value ?? 0;
    }

    dispatch(revenueReportingActions.setReports(updatedReports));
  };

  const handleChange = (e, name) => {
    let updatedReports = { ...reports };
    switch (name) {
      case "actions":
        setTouchedFields((prev) => ({
          ...prev,
          year: false,
          month: false,
        }));
        setTableData("");
        setTableShow(false);
        dispatch(revenueReportingActions.ClearRevenueSummaryList());
        if (reports?.actions !== 1) {
          updatedReports.fromDate = "";
          updatedReports.toDate = "";
          updatedReports.year = 0;
          updatedReports.month = 0;
        } else if (reports?.actions !== 2) {
          updatedReports.fromDate = "";
          updatedReports.toDate = "";
          updatedReports.dobEndDate = "";
        } else if (reports?.actions !== 3) {
          updatedReports.year = 0;
          updatedReports.month = 0;
          updatedReports.dobEndDate = "";
        }
        RemoveErrorMsg(["fromDate", "toDate", "year", "month", "dobEndDate"]);
        break;
      case "records":
        updatedReports.facilityId = 0;
        updatedReports.paymentType = "ALL";
        RemoveErrorMsg(["facilityId"]);
        setTableShow(false);
        dispatch(revenueReportingActions.ClearRevenueSummaryList());
        break;
      case "fromDate":
        updatedReports.fromDate = e?.target
          ? parseInt(e.target.value)
          : fDate(e);

        // Ensure that 'fromDate' is in the correct format (MM/DD/YYYY)

        break;
      default:
        break;
    }

    updatedReports[name] = e?.target ? parseInt(e.target.value) : fDate(e);

    dispatch(revenueReportingActions.setReports(updatedReports));

    // ✅ Clear error for the field being changed
    setErrorMessage((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const RemoveErrorMsg = (nameList) => {
    nameList.forEach((name) => {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));
    });
  };
  // Generate the dynamic years array
  const startYear = 2017;
  const startDate = new Date(2017, 0, 1);
  const currentYear = new Date().getFullYear();
  const yearsArray = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => startYear + index
  );
  const currentMonth = new Date().getMonth() + 1;

  // Transform the array for SelectInput
  // const yearOptions = yearsArray.map((year) => ({
  //   label: year.toString(), // Displayed in the dropdown
  //   value: year, // Value returned on selection
  // }));

  const yearOptions = [
    { label: "-- Select --", value: 0 }, // Initial option
    ...yearsArray.reverse().map((year) => ({
      label: year.toString(),
      value: year,
    })),
  ];

  // yearOptions.unshift({
  //   label: "Select", // Initial option text
  //   value: 0, // Initial option value
  // });

  // // Transform the array for SelectInput
  // const monthOptions = monthNames.map((month, index) => ({
  //   label: month, // Displayed in the dropdown
  //   value: index + 1, // Value returned on selection
  // }));
  // // Add the initial "Select" option
  // monthOptions.unshift({
  //   label: "Select", // Initial option text
  //   value: 0, // Initial option value
  // });

  // Take From date set 1 year restriction
  //const maxToDate = reports?.fromDate ? new Date(reports.fromDate) : new Date();
  const maxToDate = reports?.fromDate
    ? new Date(reports.fromDate).setFullYear(
      new Date(reports.fromDate).getFullYear() + 1
    )
    : new Date();

  // Function to generate month options based on the year
  function generateMonthOptions(year) {
    // Start with the default options
    let monthOptions = monthNames.map((month, index) => ({
      label: month, // Displayed in the dropdown
      value: index + 1, // Value returned on selection
    }));

    // Add the initial "Select" option
    monthOptions.unshift({
      label: "-- Select --", // Initial option text
      value: 0, // Initial option value
    });

    if (year === currentYear) {
      monthOptions = monthOptions.filter(
        (option) => option.value <= currentMonth
      );
    }

    return monthOptions;
  }

  // const handleBlur = async (e) => {
  //   const validationErrors = await validate();
  //   setErrorMessage(validationErrors);
  //   if (Object.keys(validationErrors).length !== 0) {
  //     return;
  //   }
  // };

  const handleOnBlur = (e) => {
    let { name, value } = e.target;

    // Skip validation if month is reset programmatically
    // ✅ Skip month validation if it was just reset by year
    if (
      name === "month" &&
      wasMonthResetByYear.current &&
      !wasMonthTouched.current
    ) {
      wasMonthResetByYear.current = false; // skip only once
      return; // 🚫 Don't validate
    }

    let isValid = true;
    let updatedReports = { ...reports };
    if (
      updatedReports.dobEndDate &&
      new Date(value) < new Date(updatedReports.dobEndDate)
    ) {
      // Invalid: ToDate cannot be before FromDate
      isValid = false;
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedReports,
      dobEndDate:
        name === "dobEndDate"
          ? isValid && isValidDate
            ? value.replace(/\//g, "/")
            : ""
          : updatedReports.dobEndDate.replace(/\//g, "/"), // preserve existing value
    };
    dispatch(revenueReportingActions.setReports(updatedParam));

    // const { error } = revenueReportSchema(updatedParam);

    // if (error?.details) {
    //   // Extract the error message for the specific field
    //   const fieldError = error.details.find((e) => e?.path?.[0] === name);

    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
    //   }));

    //   // Select the input element
    //   const element = document.querySelector(`[name="${name}"]`);

    //   if (element) {
    //     if (fieldError) {
    //       // Add the error class if there's a validation issue
    //       element.classList.add("input-error");
    //     } else {
    //       // Remove the error class if validation passes
    //       element.classList.remove("input-error");
    //     }
    //   }
    // } else {
    //   // Clear the error message if there's no validation error
    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     [name]: "",
    //   }));

    //   // Remove the error class from the input field
    //   const element = document.querySelector(`[name="${name}"]`);
    //   if (element) {
    //     element.classList.remove("input-error");
    //   }
    // }
    // }
  };

  //
  const handleDateBlur = (e, name) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;
    let updatedReports = { ...reports };

    const fromDate = updatedReports.fromDate;
    if (fromDate) {
      const delimiter = fromDate.includes("-") ? "-" : "/";
      const dateParts = fromDate.split(delimiter);
      const month = parseInt(dateParts[0], 10);
      const day = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);

      const fromDateObj = new Date(year, month - 1, day);

      fromDateObj.setFullYear(fromDateObj.getFullYear() + 1);
      // Get the current date
      const currentDate = new Date();
      const fromDateValid = new Date(updatedReports.fromDate);
      const toDateDateValid = new Date(updatedReports.toDate);

      // Compare the 'toDate' with the current date
      if (fromDateObj > currentDate && updatedReports.toDate === "") {
        // updatedReports.toDate = `${(currentDate.getMonth() + 1)
        //   .toString()
        //   .padStart(2, "0")}-${currentDate
        //   .getDate()
        //   .toString()
        //   .padStart(2, "0")}-${currentDate.getFullYear()}`;
      } else if (
        fromDateValid > toDateDateValid ||
        toDateDateValid > fromDateObj ||
        updatedReports.toDate === ""
      ) {
        updatedReports.toDate = `${(fromDateObj.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${fromDateObj
            .getDate()
            .toString()
            .padStart(2, "0")}-${fromDateObj.getFullYear()}`;
      }
      // setErrorMessage((prev) => ({
      //   ...prev,
      //   toDate: "",
      //   fromDate: "",
      // }));
    } else {
      updatedReports.toDate = "";
    }

    if (name === "fromDate") {
      if (
        updatedReports.toDate &&
        new Date(value) > new Date(updatedReports.toDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (name === "toDate") {
      if (
        updatedReports.fromDate &&
        new Date(value) < new Date(updatedReports.fromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;
    const setToDate = valueDate >= minDate && valueDate <= today && isFromValid;
    let updatedParam = {
      ...updatedReports,
      fromDate:
        name === "fromDate"
          ? isFromValid && isValidDate
            ? fDate(value)
            : ""
          : fDate(updatedReports.fromDate), // preserve existing value
      toDate:
        name === "fromDate" && !setToDate
          ? "" // clear toDate if fromDate is invalid or empty
          : name === "toDate"
            ? isToValid && isValidDate
              ? fDate(value)
              : ""
            : fDate(updatedReports.toDate), // preserve existing value
    };

    dispatch(revenueReportingActions.setReports(updatedParam));
    // const { error } = revenueReportSchema(updatedParam);

    // if (error?.details) {
    //   // Extract the error message for the specific field
    //   const fieldError = error.details.find((e) => e.path.toString() === name);

    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
    //   }));

    //   // Select the input element
    //   const element = document.querySelector(`[name="${name}"]`);

    //   if (element) {
    //     if (fieldError) {
    //       // Add the error class if there's a validation issue
    //       element.classList.add("input-error");
    //     } else {
    //       // Remove the error class if validation passes
    //       element.classList.remove("input-error");
    //     }
    //   }
    // } else {
    //   // Clear the error message if there's no validation error
    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     [name]: "",
    //   }));

    //   // Remove the error class from the input field
    //   const element = document.querySelector(`[name="${name}"]`);
    //   if (element) {
    //     element.classList.remove("input-error");
    //   }
    // }
  };

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    let updatedState = "";
    updatedState = `${column.key} ${reports?.sortBy.includes(column.key)
      ? reports?.sortBy.includes("asc")
        ? "desc"
        : "asc"
      : "asc"
      }`;
    dispatch(
      revenueReportingActions.setReports({
        ...reports,
        sortBy: updatedState,
      })
    );
    switch (currentShowingTable) {
      case "PurchasedCreditsMonthly":
        let params = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: 1,
          pageNo: reports?.pageNo,
          rowCountPerPage:
            reports?.rowCountPerPage !== "" ? reports?.rowCountPerPage : 10,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          SortBy: updatedState,
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            params
          )
        ).then((res) => {
          let result = res?.payload;
          //dispatch(revenueReportingActions.setmonthlyPOtransaction(result));
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(purchaseCreditColumns);
          setTableTitle("PURCHASED CREDITS");
        });
        break;
      case "PurchasedCreditsDaily":
        let param = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: 1,
          pageNo: reports?.pageNo,
          rowCountPerPage:
            reports?.rowCountPerPage !== "" ? reports?.rowCountPerPage : 10,
          SortBy: updatedState,
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(param)
        ).then((res) => {
          let result = res?.payload;
          //dispatch(revenueReportingActions.setdailyPOtransaction(result));
          setTableShow(true);
          setTableData(result?.DataList);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableColumn(purchaseCreditColumns);
          setTableTitle("PURCHASED CREDITS");
        });
        break;
      case "FailedTransactionsMonthly":
        let failedmonthlyvalue = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: -1,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          SortBy: updatedState,
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            failedmonthlyvalue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result.DataList);
          setTableColumn(failedTransactionColumns);
          setTableTitle("FAILED TRANSACTIONS");
        });
        break;
      case "FailedTransactionsDaily":
        let faileddailyvalue = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: -1,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          SortBy: updatedState,
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            faileddailyvalue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result.DataList);
          setTableColumn(failedTransactionColumns);
          setTableTitle("FAILED TRANSACTIONS");
        });
        break;
      case "PendingTransactionsMonthly":
        let pendingmonthlyvalue = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: 0,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          SortBy: updatedState,
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            pendingmonthlyvalue
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result.DataList);
          setTableColumn(pendingTransactionColumns);
          setTableTitle("PENDING TRANSACTIONS");
        });
        break;
      case "PendingTransactionsDaily":
        let pendingDailytrans = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: 0,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          SortBy: updatedState,
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            pendingDailytrans
          )
        ).then((res) => {
          let result = res?.payload;
          //dispatch(revenueReportingActions.setdailyPOtransaction(result));
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result.DataList);
          setTableColumn(pendingTransactionColumns);
          setTableTitle("PENDING TRANSACTIONS");
        });
        break;
      case "FreeCreditsMonthly":
        let freeCreditsMonthly = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedState,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyFreeCreditsList(freeCreditsMonthly)
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(freeCreditColumns);
          setTableTitle("FREE CREDITS");
        });
        break;
      case "FreeCreditsDaily":
        let freecreditDailytrans = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: updatedState,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
        };
        dispatch(
          revenueReportingActions.LoadDailyFreeCreditsList(freecreditDailytrans)
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(freeCreditColumns);
          setTableTitle("FREE CREDITS");
        });
        break;
      case "CactasCreditsMonthly":
        let CactasCreditsmonthly = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedState,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyCactasCreditsList(
            CactasCreditsmonthly
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(CactasCreditsColumns);
          setTableTitle("CACTAS CREDITS");
        });
        break;
      case "CactasCreditsDaily":
        let cactasCreditsDaily = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: updatedState,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
        };
        dispatch(
          revenueReportingActions.LoadDailyCactasCreditsList(cactasCreditsDaily)
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(CactasCreditsColumns);
          setTableTitle("CACTAS CREDITS");
        });
        break;
      case "CactasRefund":
        let cactasRefund = {
          facilityID: reports?.facilityId,
          inmateResidentID: "",
          firstName: "",
          lastName: "",
          taskNo: 0,
          refundTaskNo: 0,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedState,
          pageNo: reports?.pageNo,
          rowCountPerPage: reports?.rowCountPerPage,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(
            cactasRefund
          )
        ).then((res) => {
          let result = res?.payload;
          setTableShow(true);
          setTableTotalRecord(result?.TotalRecordCount);
          setTableData(result?.DataList);
          setTableColumn(CactasRefundColumns);
          setTableTitle("CACTAS REFUND");
        });
        break;

      default:
        break;
    }
  };

  // JOI validation function
  // const validate = async () => {
  //   try {
  //     await revenueReportSchema.validateAsync(reports, {
  //       abortEarly: false,
  //     });
  //     return {};
  //   } catch (err) {
  //     const validationErrors = {};
  //     err.details.forEach((error) => {
  //       const field = error.path[0]; // Get the actual field name from the error path
  //       validationErrors[field] = error.message; // Use the correct field name
  //     });
  //     return validationErrors;
  //   }
  // };

  const handleSearch = async (e) => {
    e?.preventDefault();
    setTableShow(false);
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = revenueReportSchema(reports);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`input[name="${path}"]`);
        if (inputElement) {
          // Add the input-error class if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    // Check if the year and month are selected or if dobEndDate is provided
    let fromDate = fDate(reports?.fromDate);
    let toDate = fDate(reports?.toDate);

    // Check if year and month are selected (both year and month must exist)
    if (reports?.year && reports?.month) {
      // If year and month are provided, set fromDate and toDate
      fromDate = new Date(reports.year, reports.month - 1, 1); // First day of the month
      toDate = new Date(reports.year, reports.month, 0); // Last day of the month
    }

    // If dobEndDate is provided, use it as both fromDate and toDate
    if (reports?.dobEndDate) {
      fromDate = new Date(reports.dobEndDate);
      toDate = new Date(reports.dobEndDate);
    }

    // Prepare params with formatted dates
    let params = {
      facilityId: reports?.facilityId,
      paymentType: reports?.paymentType,
      fromDate: fDate(fromDate),
      toDate: fDate(toDate),
    };
    dispatch(
      revenueReportingActions.setReports({
        ...reports,
        sortBy: ""
      })
    );
    // Dispatch the action if fromDate is available
    if (fromDate) {
      dispatch(revenueReportingActions.GetRevenueSummaryList(params));
    }
  };

  useEffect(() => {
    handleReset();
  }, [isPageReloading])

  const handleReset = () => {
    // Reset Redux state
    dispatch(revenueReportingActions.resetRevenueReports());
    dispatch(revenueReportingActions.ClearRevenueSummaryList());

    // Reset local component state (if any)
    setTableShow(false);
    setTableData([]);
    setTableColumn([]);
    setTableTitle([]);
    setTableTotalRecord([]);
    setCurrentShowingTable("");
    setErrorMessage({});

    // Remove validation classes
    document.querySelectorAll(".input-error, .is-invalid").forEach((el) => {
      el.classList.remove("input-error", "is-invalid");
    });
    setResetFlag(true);
  };

  const photoCost =
    revenueSummaryList?.TotalPhotoAmt - revenueSummaryList?.TotalPhotoEmojiCost;

  const eCardCost =
    revenueSummaryList?.TotalECardAmt - revenueSummaryList?.TotalECardEmojiCost;

  const handleScrollupdate = () => {
    const UpdatepageScroll = isPageScroll + 1;
    setTimeout(() => {
      dispatch(revenueReportingActions?.updateScroll(UpdatepageScroll));
    }, 100);
  }

  const handleTableClick = (name) => {
    let updatedReports = { ...reports };
    updatedReports.pageNo = 1;
    updatedReports.rowCountPerPage = 10;
    dispatch(revenueReportingActions.setReports(updatedReports));
    switch (name) {
      case "PurchasedCredits":
        setCurrentShowingTable("PurchasedCreditsMonthly");
        if (revenueSummaryList?.TotalPurchaseCreditSuccess > 0) {
          if (reports?.actions === 2 || reports?.actions === 3) {
            let params = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 1,
              pageNo: 1,
              rowCountPerPage: 10,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
              SortBy: "",
            };
            // setReports((prevState) => ({
            //   ...prevState,
            //   rowCountPerPage: 10,
            //   pageNo: 1,
            // }));
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                params
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setmonthlyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(purchaseCreditColumns);
              handleScrollupdate();
              setTableTitle("PURCHASED CREDITS");
            });
          } else {
            setCurrentShowingTable("PurchasedCreditsDaily");
            let param = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 1,
              pageNo: 1,
              rowCountPerPage: 10,
              SortBy: "",
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                param
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableData(result?.DataList);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableColumn(purchaseCreditColumns);
              handleScrollupdate();
              setTableTitle("PURCHASED CREDITS");
            });
          }
        } else {
          showToastNotification("No Transactions Found", "error");
        }
        break;
      case "FailedTransactions":
        setCurrentShowingTable("FailedTransactionsMonthly");
        if (revenueSummaryList?.TotalPurchaseCreditFailed > 0) {
          if (reports?.actions === 2 || reports?.actions === 3) {
            let failedmonthlyTrans = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: -1,
              pageNo: 1,
              rowCountPerPage: 10,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
              SortBy: "",
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                failedmonthlyTrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setmonthlyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(failedTransactionColumns);
              handleScrollupdate();
              setTableTitle("FAILED TRANSACTIONS");
            });
          } else {
            setCurrentShowingTable("FailedTransactionsDaily");
            let faileddailyTrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: -1,
              pageNo: 1,
              rowCountPerPage: 10,
              SortBy: "",
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                faileddailyTrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(failedTransactionColumns);
              handleScrollupdate();
              setTableTitle("FAILED TRANSACTIONS");
            });
          }
        } else {
          showToastNotification("No Transactions Found", "error");
        }
        break;
      case "PendingTransactions":
        setCurrentShowingTable("PendingTransactionsMonthly");
        if (revenueSummaryList?.TotalPurchaseCreditPending > 0) {
          if (reports?.actions === 2 || reports?.actions === 3) {
            let pendingmonthlytrans = {
              facilityID: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              transactionSucess: 0,
              pageNo: 1,
              rowCountPerPage: 10,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
              SortBy: "",
            };
            dispatch(
              revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
                pendingmonthlytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setmonthlyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(pendingTransactionColumns);
              handleScrollupdate();
              setTableTitle("PENDING TRANSACTIONS");
            });
          } else {
            setCurrentShowingTable("PendingTransactionsDaily");
            let pendingDailytrans = {
              facilityId: reports?.facilityId,
              paymentType:
                reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              dobEndDate: fDate(reports?.dobEndDate),
              transactionSucess: 0,
              pageNo: 1,
              rowCountPerPage: 10,
              SortBy: "",
            };
            dispatch(
              revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
                pendingDailytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyPOtransaction(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(pendingTransactionColumns);
              handleScrollupdate();
              setTableTitle("PENDING TRANSACTIONS");
            });
          }
        } else {
          showToastNotification("No Transactions Found", "error");
        }
        break;
      case "FreeCredits":
        setCurrentShowingTable("FreeCreditsMonthly");
        if (revenueSummaryList?.TotalInmateFreeCredit > 0) {
          if (reports?.actions === 2 || reports?.actions === 3) {
            let freeCreditmonthlytrans = {
              facilityID: reports?.facilityId,
              // paymentType:
              //   reports?.paymentType === "ALL" ? "" : reports?.paymentType,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              sortBy: "",
              pageNo: 1,
              rowCountPerPage: 10,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyFreeCreditsList(
                freeCreditmonthlytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setmonthlyFCList(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(freeCreditColumns);
              handleScrollupdate();
              setTableTitle("FREE CREDITS");
            });
          } else {
            setCurrentShowingTable("FreeCreditsDaily");
            let freecreditDailytrans = {
              facilityId: reports?.facilityId,
              selectDate: fDate(reports?.dobEndDate),
              sortBy: "",
              pageNo: 1,
              rowCountPerPage: 10,
            };
            dispatch(
              revenueReportingActions.LoadDailyFreeCreditsList(
                freecreditDailytrans
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyFCList(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(freeCreditColumns);
              handleScrollupdate();
              setTableTitle("FREE CREDITS");
            });
          }
        } else {
          showToastNotification("No Transactions Found", "error");
        }

        break;
      case "CactasCredits":
        setCurrentShowingTable("CactasCreditsMonthly");
        if (revenueSummaryList?.TotalInmateCactasCreditAmount > 0) {
          if (reports?.actions === 2 || reports?.actions === 3) {
            let CactasCreditsmonthly = {
              facilityID: reports?.facilityId,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              sortBy: "",
              pageNo: 1,
              rowCountPerPage: 10,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };
            dispatch(
              revenueReportingActions.LoadMonthlyCactasCreditsList(
                CactasCreditsmonthly
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setmonthlyCCList(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(CactasCreditsColumns);
              handleScrollupdate();
              setTableTitle("CACTAS CREDITS");
            });
          } else {
            setCurrentShowingTable("CactasCreditsDaily");
            let cactasCreditsDaily = {
              facilityId: reports?.facilityId,
              selectDate: fDate(reports?.dobEndDate),
              sortBy: "",
              pageNo: 1,
              rowCountPerPage: 10,
            };
            dispatch(
              revenueReportingActions.LoadDailyCactasCreditsList(
                cactasCreditsDaily
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdailyCCList(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(CactasCreditsColumns);
              handleScrollupdate();
              setTableTitle("CACTAS CREDITS");
            });
          }
        } else {
          showToastNotification("No Transactions Found", "error");
        }

        break;
      case "CactasRefund":
        if (revenueSummaryList?.TotalCactasAmountRefund > 0) {
          setCurrentShowingTable("CactasRefund");
          if (reports?.actions === 2 || reports?.actions === 3) {
            let cactasRefund = {
              facilityID: reports?.facilityId,
              inmateResidentID: "",
              firstName: "",
              lastName: "",
              taskNo: 0,
              refundTaskNo: 0,
              month: reports?.actions === 3 ? 0 : reports?.month,
              year: reports?.actions === 3 ? 0 : reports?.year,
              sortBy: "",
              pageNo: 1,
              rowCountPerPage: 10,
              fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
              toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
            };

            dispatch(
              revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(
                cactasRefund
              )
            ).then((res) => {
              let result = res?.payload;
              //dispatch(revenueReportingActions.setdicrepancyCRFList(result));
              setTableShow(true);
              setTableTotalRecord(result?.TotalRecordCount);
              setTableData(result?.DataList);
              setTableColumn(CactasRefundColumns);
              handleScrollupdate();
              setTableTitle("CACTAS REFUND");
              dispatch(
                revenueReportingActions.LoadInmateFirstNames({
                  facilityID: reports?.facilityId,
                  lastName: "",
                  sortBy: "",
                })
              );
              dispatch(
                revenueReportingActions.LoadInmateLastNames({
                  facilityID: reports?.facilityId,
                  firstName: "",
                  sortBy: "",
                })
              );
            });
          }
        } else {
          showToastNotification("No Transactions Found", "error");
        }

        break;
      default:
        break;
    }
  };

  const handleOrderId = (row) => {
    let PurchaseOrderTransactionID = row?.PurchaseOrderTransactionID;
    if (PurchaseOrderTransactionID) {
      dispatch(
        revenueReportingActions.GetUserPaymentInfo(PurchaseOrderTransactionID)
      );
    }
  };

  const purchaseCreditColumns = [
    {
      name: "Date",
      key: "TransactionDate",
      selector: (row) => row?.TransactionDate,
      cell: (row) => (
        <div title={row?.TransactionDate}>{row?.TransactionDate}</div>
      ),
      center: true,
      sortable: true,
    },
    {
      name: "Date On Gateway",
      key: "TransDate",
      selector: (row) => row?.TransDate,
      cell: (row) => <div title={row?.TransDate}>{row?.TransDate}</div>,
      center: true,
      sortable: true,
    },
    {
      name: "Order Id",
      key: "POTransactionRandomID",
      selector: (row) => row?.PayPalTransactionID,
      sortable: true,
      cell: (row) => (
        <div
          data-bs-toggle="modal"
          data-bs-target="#revenue-orderId-modal"
          className="Common_Link_Style"
          onClick={() => handleOrderId(row)}
        >
          {row?.POTransactionRandomID}
        </div>
      ),
    },
    {
      name: "Name",
      key: "PublicUserName",
      selector: (row) => row?.PublicUserName,
      sortable: true,
      center: true,
    },
    {
      name: "Name On Gateway",
      key: "TransactionName",
      selector: (row) => row?.TransactionName,
      sortable: true,
    },
    {
      name: "Payment Type",
      key: "PaymentType",
      selector: (row) => row?.PaymentType,
      sortable: true,
      center: true,
    },
    {
      name: "Amount ($)",
      key: "PurchaseAmount",
      selector: (row) => row?.PurchaseAmount.toFixed(2),
      sortable: true,
      center: true,
    },
    {
      name: "Payment Status",
      key: "PaymentStatus",
      selector: (row) => row?.PaymentStatus,
      sortable: true,
      center: true,
    },

    {
      name: "Action",
      selector: (row) => row?.TransactionSuccess,
      sortable: false,
      cell: (row) => (
        <div>
          {row?.TransactionSuccess === 1 ? (
            // <i
            //   className="fa-solid fa-thumbs-up fs-3"
            //   style={{ color: "#4a9a93" }}
            //   title="Confirmed"
            // ></i>
            <span className="status-open">Confirmed</span>
          ) : (
            // <i
            //   className="fa-regular fa-thumbs-down fs-3"
            //   style={{ color: "#4a9a93" }}
            //   title="Failed"
            // ></i>
            <span className="status-Closed">Failed</span>
          )}
        </div>
      ),
      sortable: false,
      center: true,
      // right: true,
      // left: true,
    },
  ];
  const failedTransactionColumns = [
    {
      name: "Date",
      key: "TransactionDate",
      selector: (row) => row?.TransactionDate,
      sortable: true,
      cell: (row) => (
        <div title={row?.TransactionDate}>{row?.TransactionDate}</div>
      ),
      center: true,
    },
    {
      name: "Date On Gateway",
      key: "TransDate",
      selector: (row) => row?.TransDate,
      sortable: true,
      cell: (row) => <div title={row?.TransDate}>{row?.TransDate}</div>,
      center: true,
    },
    {
      name: "Order Id",
      key: "POTransactionRandomID",
      selector: (row) => row?.PayPalTransactionID,
      sortable: true,
      cell: (row) => (
        <div
          data-bs-toggle="modal"
          data-bs-target="#revenue-orderId-modal"
          className="Common_Link_Style"
          onClick={() => handleOrderId(row)}
        >
          {row?.POTransactionRandomID}
        </div>
      ),
    },
    {
      name: "Name",
      key: "PublicUserName",
      selector: (row) => row?.PublicUserName,
      sortable: true,
      cell: (row) => (
        <div title={row?.PublicUserName}>{row?.PublicUserName}</div>
      ),
      center: true,
    },
    {
      name: "Name On Gateway",
      key: "TransactionName",
      selector: (row) => row?.TransactionName,
      sortable: true,
    },
    {
      name: "Payment Type",
      key: "PaymentType",
      selector: (row) => row?.PaymentType,
      sortable: true,
      center: true,
    },
    {
      name: "Amount ($)",
      key: "PurchaseAmount",
      selector: (row) => row?.PurchaseAmount.toFixed(2),
      sortable: true,
      center: true,
    },
    {
      name: "Payment Status",
      key: "PaymentStatus",
      selector: (row) => row?.PaymentStatus,
      sortable: true,
      center: true,
    },

    {
      name: "Action",
      selector: (row, i) => row?.PurchaseOrderTransactionID,
      sortable: false,
      cell: (row) => (
        <>
          {/* Check for TransactionSuccess and other conditions */}
          {(row?.TransactionSuccess === 0 || row?.TransactionSuccess === -1) &&
            row?.IsManuallyUpdateTransaction === 1 &&
            row?.IsAllowTransactionFailedUpdate === 1 ? (
            <>
              <i
                className="fa-solid fa-circle-check cursor-pointer fs-2"
                style={{ color: "#4a9a93" }}
                title="Confirm"
                onClick={() => {
                  handleConfirmation(row, "failedTransConfirm");
                }}
              ></i>
              <i
                className="fa-solid fa-xmark cursor-pointer fs-2 ms-3"
                style={{ color: "#cc5a5a" }}
                title="Cancel"
                onClick={() => {
                  handleConfirmation(row, "failedTransCancel");
                }}
              ></i>
            </>
          ) : row?.TransactionSuccess === -1 &&
            row?.IsManuallyUpdateTransaction === 1 &&
            row?.IsAllowTransactionFailedUpdate === 0 ? (
            // <i
            //   className="fa-solid fa-thumbs-down fs-3"
            //   style={{ color: "#4a9a93" }}
            //   title="Canceled"
            // ></i>
            <span title="Canceled" className="status-Closed">
              FAILED
            </span>
          ) : (
            <div title="Update Payment">
              <Button
                className={"btn-xs"}
                label="Update"
                type="submit"
                variant="danger"
                icon={"fa-solid fa-pen-to-square"}
                status={"primary"}
                onClick={() => {
                  handleUpdate(row, "failedTransUpdate");
                }}
                disabled={false}
              />
            </div>
          )}
        </>
      ),

      sortable: false,
      center: true,
      // right: true,
      // left: true,
    },
  ];
  const pendingTransactionColumns = [
    {
      name: "Date",
      key: "TransactionDate",
      selector: (row) => row?.TransactionDate,
      sortable: true,
      cell: (row) => (
        <div title={row?.TransactionDate}>{row?.TransactionDate}</div>
      ),
      center: true,
    },
    {
      name: "Date On Gateway",
      key: "TransDate",
      selector: (row) => row?.TransDate,
      sortable: true,
      cell: (row) => <div title={row?.TransDate}>{row?.TransDate}</div>,
      center: true,
    },
    {
      name: "Order Id",
      key: "POTransactionRandomID",
      selector: (row) => row?.PayPalTransactionID,
      sortable: true,
      cell: (row) => (
        <div
          data-bs-toggle="modal"
          data-bs-target="#revenue-orderId-modal"
          className="Common_Link_Style"
          onClick={() => handleOrderId(row)}
        >
          {row?.POTransactionRandomID}
        </div>
      ),
    },
    {
      name: "Name",
      key: "PublicUserName",
      selector: (row) => row?.PublicUserName,
      sortable: true,
      center: true,
    },
    {
      name: "Name On Gateway",
      key: "TransactionName",
      selector: (row) => row?.TransactionName,
      sortable: true,
    },
    {
      name: "Payment Type",
      key: "PaymentType",
      selector: (row) => row?.PaymentType,
      sortable: true,
      center: true,
    },
    {
      name: "Amount ($)",
      key: "PurchaseAmount",
      selector: (row) => row?.PurchaseAmount.toFixed(2),
      sortable: true,
      center: true,
    },
    {
      name: "Payment Status",
      key: "PaymentStatus",
      selector: (row) => row?.PaymentStatus,
      sortable: true,
      center: true,
    },

    {
      name: "Action",
      sortable: false,
      selector: (row) => (
        <div>
          <div className="mb-3" title="Update Payment">
            <Button
              label="Update"
              className={"btn-xs"}
              type="submit"
              variant="danger"
              icon={"fa-solid fa-pen-to-square"}
              status={"primary"}
              onClick={() => {
                handleUpdate(row, "pendingTransUpdate");
              }}
              disabled={false}
            />
          </div>
          {Payment_Approvers.includes(loggedUser) &&
            <div>
              <i
                className="fa-solid fa-circle-check cursor-pointer fs-2"
                style={{ color: "#4a9a93" }}
                title="Confirm"
                onClick={() => {
                  handleConfirmation(row, "pendingTransConfirm");
                }}
              ></i>

              <i
                className="fa-solid fa-xmark cursor-pointer fs-2 ms-3"
                style={{ color: "#cc5a5a" }}
                title="Cancel"
                onClick={() => {
                  handleConfirmation(row, "pendingTransCancel");
                }}
              ></i>
            </div>
          }
        </div>
      ),
      sortable: false,
      center: true,
      // right: true,
      // left: true,
    },
  ];
  const freeCreditColumns = [
    {
      name: "Date",
      key: "InmateFreeCreditDate",
      selector: (row) => row?.InmateFreeCreditDate,
      sortable: true,
      center: true,
    },

    {
      name: "Amount ($)",
      key: "InmateFreeCreditAmount",
      selector: (row) => row?.InmateFreeCreditAmount.toFixed(2),
      sortable: true,
      center: true,
    },
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row?.InmateResidentId,
      sortable: true,
      center: true,
    },
    {
      name: "	Inmate Name",
      key: "InmateName",
      selector: (row) => row?.InmateName,
      sortable: true,
      center: true,
    },
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row?.FacilityCode,
      sortable: true,
      center: true,
    },
  ];
  const CactasCreditsColumns = [
    {
      name: "Task No",
      key: "TaskNo",
      selector: (row) => (row?.TaskNo != 0 ? row?.TaskNo : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "Date",
      key: "CactasTransactionDate",
      selector: (row) => row?.CactasTransactionDate,
      sortable: true,
      cell: (row) => (
        <div title={row?.CactasTransactionDate}>
          {row?.CactasTransactionDate}
        </div>
      ),
      center: true,
    },
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row?.InmateResidentId,
      sortable: true,
      center: true,
    },
    {
      name: "	Inmate Last Name",
      key: "LastName",
      selector: (row) => row?.LastName,
      sortable: true,
      center: true,
    },
    {
      name: "Inmate First Name",
      key: "FirstName",
      selector: (row) => row?.FirstName,
      sortable: true,
      center: true,
    },
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row?.FacilityCode,
      sortable: true,
      center: true,
    },

    {
      name: "Amount ($)",
      key: "Amount",
      selector: (row) => row?.Amount.toFixed(2),
      sortable: true,
      center: true,
    },

    {
      name: "Transaction Type",
      key: "CreditAmount",
      selector: (row) => (parseInt(row?.CreditAmount) > 0 ? "Refund" : "Debit"),
      sortable: true,
      center: true,
    },
  ];
  const CactasRefundColumns = [
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row?.FacilityCode,
      sortable: true,
      center: true,
    },
    {
      name: "Inmate ID",
      key: "ResidentId",
      selector: (row) => row?.ResidentId,
      sortable: true,
      center: true,
    },
    {
      name: "Inmate Name",
      key: "InmateFullName",
      selector: (row) => row?.InmateFullName,
      sortable: true,
      center: true,
    },
    {
      name: "Transaction Type",
      key: "CreditAmount",
      selector: (row) => (parseInt(row?.CreditAmount) > 0 ? "Refund" : "Debit"),
      sortable: true,
      center: true,
    },
    {
      name: "Task No",
      key: "TaskNo",
      selector: (row) => row?.TaskNo,
      sortable: true,
      center: true,
    },
    {
      name: "Refund Task No",
      key: "RefundTaskNo",
      selector: (row) => row?.RefundTaskNo,
      sortable: true,
      center: true,
    },

    {
      name: "Task GUID",
      key: "TaskGUID",
      selector: (row) => row?.TaskGUID,
      sortable: true,
      center: true,
    },
    {
      name: "Refund Task GUID",
      key: "RefundTaskGUID",
      selector: (row) => row?.RefundTaskGUID,
      sortable: true,
      center: true,
    },
    {
      name: "Amount ($)",
      key: "Amount",
      selector: (row) => row?.Amount.toFixed(2),
      sortable: true,
      center: true,
    },
    {
      name: "Task Date",
      key: "TaskDate",
      selector: (row) => formatDateTime(row.TaskDate),
      sortable: true,
      center: true,
    },
    {
      name: "Refund Date",
      key: "RefundedDate",
      // selector: (row) => row?.RefundedDate,
      selector: (row) => formatDateTime(row.RefundedDate),
      sortable: true,
      center: true,
    },
  ];

  const handleConfirmation = (row, name) => {
    if (name === "failedTransConfirm" || name === "pendingTransConfirm") {
      const payload = {
        poTransactionRandomID: row?.POTransactionRandomID,
        transactionPurpose: "null",
        isLoginValid: 1,
        isManuallyUpdated: 1,
        manuallyUpdatedType: "",
        createdBy: user?.ManagementUserID,
        transactionName: row?.TransactionName,
        transactionEmail: row?.TransactionEmail,
        transDate: row?.TransDate,
        resultType: row?.PaymentType,
        isPaymentIntentMethod: true,
      };
      if (payload) {
        Popup({
          title: "Message",
          text: `Are you sure you want to confirm?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () => {
            dispatch(
              revenueReportingActions.PurchaseOrderTransactionStatusUpdate(
                payload
              )
            );
            setPOTransactionRandomID(row?.POTransactionRandomID);
          },
        });
      }
    } else {
      const payload = {
        poTransactionRandomID: row?.POTransactionRandomID,
        transactionPurpose: "null",
        isLoginValid: -1,
        isManuallyUpdated: 1,
        manuallyUpdatedType: "",
        createdBy: user?.ManagementUserID,
        transactionName: row?.TransactionName,
        transactionEmail: row?.TransactionEmail,
        transDate: row?.TransDate,
        resultType: row?.PaymentType,
        isPaymentIntentMethod: true,
      };
      if (payload) {
        Popup({
          title: "Message",
          text: `Are you sure you want to cancel?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              revenueReportingActions.PurchaseOrderTransactionStatusUpdate(
                payload
              )
            ),
        });
      }
    }
  };

  const handlesendMail = (x, row) => {
    var res = x?.payload;
    if (res?.StripResponce == 0 || res?.StripResponce == -1) {
      const mailpayload = {
        name: row?.CreditCardHolderName,
        emailId: row?.TransactionEmail,
        poTransactionID: row?.PayPalTransactionID,
        poTransactionRandomID: row?.POTransactionRandomID,
        stripeResponse: res?.StripResponce == 0 ? "Transaction Pending" : "Transaction Failed",
        processingFee: row?.ProcessingFee,
        amount: row?.TotalAmount,
        transactionDate: row?.TransactionDate

      };
      dispatch(revenueReportingActions.SendMailForFailedTransaction(mailpayload));
    }
  }

  const handleUpdate = (row, name) => {
    if (name === "failedTransUpdate") {
      const payload = {
        IsPaymentIntentMethod: true,
        date: row?.TransactionDate,
        transactionRandomID: row?.POTransactionRandomID,
        TransactionEmail: row?.TransactionEmail,
        paymentType: row?.PaymentType,
      };
      dispatch(revenueReportingActions.POTPaymantTrasactionUpdate(payload)).then((x) => {
        //   handlesendMail(x, row);
      })
    } else {
      const payload = {
        IsPaymentIntentMethod: false,
        date: row?.TransactionDate,
        transactionRandomID: row?.POTransactionRandomID,
        TransactionEmail: row?.TransactionEmail,
        paymentType: row?.PaymentType,
      };
      dispatch(revenueReportingActions.POTPaymantTrasactionUpdate(payload)).then((x) => {
        //    handlesendMail(x, row);
      })
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // Return the original value if it's not a valid date

    // Format date and time separately
    const datePart = date.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    const timePart = date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    // Concatenate the date and time without a comma
    return `${datePart} ${timePart}`;
  };

  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    let updatedReports = { ...reports };
    if (tableTotalRecord + updatedReports.rowCountPerPage > tableTotalRecord) {
      updatedReports.pageNo = 1;
    }
    if (sorting) {
      sorting = false;
      return;
    }
    if (value > 0) {
      updatedReports.pageNo = value;
      dispatch(revenueReportingActions.setReports(updatedReports));
    }
  };
  const RowsCountPerPage = (value) => {
    let updatedReports = { ...reports };
    if (tableTotalRecord + updatedReports.rowCountPerPage > tableTotalRecord) {
      updatedReports.pageNo = 1;
    }
    updatedReports.rowCountPerPage = value;
    dispatch(revenueReportingActions.setReports(updatedReports));
  };

  const handleStatusChange = (selectedOption, name) => {
    const values = { ...reports };
    const statusValue = selectedOption?.label;

    if (name === "firstName") {
      values[name] = selectedOption?.value > 0 ? selectedOption?.label : "";
      values.firstNameValue = selectedOption?.value || 0;
      values.firstName = selectedOption?.value > 0 ? statusValue : "";
      // setReports(values);
      // dispatch(
      //   revenueReportingActions?.LoadInmateLastNames({
      //     facilityID:  reports?.facilityId,
      //     firstName: values?.firstName,
      //     sortBy: "",
      //   })
      // );
      if (selectedOption?.value === 0) {
        values["lastName"] = selectedOption?.value === 0 ? "" : values.lastName;
        values["lastNameValue"] =
          selectedOption?.value === 0 ? 0 : values.lastNameValue;
        dispatch(
          revenueReportingActions?.LoadInmateFirstNames({
            facilityID: reports?.facilityId,
            lastName: values?.lastName,
            sortBy: "",
          })
        );
      }
      dispatch(revenueReportingActions.setReports(values));
    } else {
      values[name] = selectedOption?.value > 0 ? selectedOption?.label : "";
      values.lastNameValue = selectedOption?.value || 0;
      values.lastName = selectedOption?.value > 0 ? statusValue : "";
      //setReports(values);
      dispatch(
        revenueReportingActions?.LoadInmateFirstNames({
          facilityID: reports?.facilityId,
          lastName: values?.lastName,
          sortBy: "",
        })
      );
      values["firstName"] = "";
      values["firstNameValue"] = 0;
      if (selectedOption?.value === 0) {
        dispatch(
          revenueReportingActions?.LoadInmateLastNames({
            facilityID: reports?.facilityId,
            firstName: values?.firstName,
            sortBy: "",
          })
        );
      }
      dispatch(revenueReportingActions.setReports(values));
    }
    let parameter = {
      facilityID: values?.facilityId,
      inmateResidentID: values?.inmateResidentID,
      firstName: values?.firstName || "",
      lastName: values?.lastName || "",
      taskNo: values?.taskNo || 0,
      refundTaskNo: values?.refundTaskNo || 0,
      month: values?.actions === 3 ? 0 : values?.month,
      year: values?.actions === 3 ? 0 : values?.year,
      sortBy: "",
      pageNo: values?.pageNo,
      rowCountPerPage: values?.rowCountPerPage,
      fromDate: values?.actions === 2 ? "" : fDate(values?.fromDate),
      toDate: values?.actions === 2 ? "" : fDate(values?.toDate),
    };
    dispatch(
      revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(parameter)
    ).then((res) => {
      let result = res?.payload;
      setTableShow(true);
      setTableTotalRecord(result?.TotalRecordCount);
      setTableData(result?.DataList);
      setTableColumn(CactasRefundColumns);
      setTableTitle("CACTAS REFUND");
    });
  };

  const handleCactasChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z0-9\s]*$/;
    let updatedReports = { ...reports };
    if (!regex.test(value)) {
      return;
    }

    if (value.trim() === "" && value !== "") {
      return;
    }

    if (
      name === "inmateResidentID" ||
      name === "taskNo" ||
      name === "refundTaskNo"
    ) {
      updatedReports[name] = value.replace(/[^0-9]/g, "");
    } else {
      updatedReports[name] = value;
    }
    dispatch(revenueReportingActions.setReports(updatedReports));
  };

  //Click the Enter Btn need to select the Current Date
  const handleDateEnterKey = (event, name) => {
    let updatedReports = { ...reports };
    if (event.key === "Enter" && updatedReports[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleCactusSearch = (e) => {
    e.preventDefault();
    let parameter = {
      facilityID: reports?.facilityId,
      inmateResidentID: reports?.inmateResidentID,
      firstName: reports?.firstName || "",
      lastName: reports?.lastName || "",
      taskNo: reports?.taskNo || 0,
      refundTaskNo: reports?.refundTaskNo || 0,
      month: reports?.actions === 3 ? 0 : reports?.month,
      year: reports?.actions === 3 ? 0 : reports?.year,
      sortBy: "",
      pageNo: reports?.pageNo,
      rowCountPerPage: reports?.rowCountPerPage,
      fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
      toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
    };
    // if (
    //   reports?.taskNo ||
    //   reports?.refundTaskNo ||
    //   reports?.inmateResidentID ||
    //   reports?.firstName ||
    //   reports?.lastName
    // ) {
    dispatch(
      revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(parameter)
    ).then((res) => {
      let result = res?.payload;
      setTableShow(true);
      setTableTotalRecord(result?.TotalRecordCount);
      setTableData(result?.DataList);
      setTableColumn(CactasRefundColumns);
      setTableTitle("CACTAS REFUND");
    });
    // }
  };

  const handleCactusReset = () => {
    let cactasRefund = {
      facilityID: reports?.facilityId,
      inmateResidentID: "",
      firstName: "",
      lastName: "",
      taskNo: 0,
      refundTaskNo: 0,
      month: reports?.actions === 3 ? 0 : reports?.month,
      year: reports?.actions === 3 ? 0 : reports?.year,
      sortBy: "",
      pageNo: reports?.pageNo,
      rowCountPerPage: reports?.rowCountPerPage,
      fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
      toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
    };
    dispatch(
      revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(
        cactasRefund
      )
    ).then((res) => {
      let result = res?.payload;
      setTableShow(true);
      setTableTotalRecord(result?.TotalRecordCount);
      setTableData(result.DataList);
      setTableColumn(CactasRefundColumns);
      setTableTitle("CACTAS REFUND");
    });
    let updatedReports = { ...reports };
    updatedReports.inmateResidentID = "";
    updatedReports.firstName = "";
    updatedReports.firstNameValue = 0;
    updatedReports.lastName = "";
    updatedReports.lastNameValue = 0;
    updatedReports.taskNo = 0;
    updatedReports.refundTaskNo = 0;
    updatedReports.pageNo = 1;
    updatedReports.rowCountPerPage = 10;
    dispatch(revenueReportingActions.setReports(updatedReports));
    //  setReports(cactusreset);
    //setTableShow(false);
    //setCurrentShowingTable("");
    dispatch(
      revenueReportingActions?.LoadInmateFirstNames({
        facilityID: reports?.facilityId,
        lastName: "",
        sortBy: "",
      })
    );
    dispatch(
      revenueReportingActions?.LoadInmateLastNames({
        facilityID: reports?.facilityId,
        firstName: "",
        sortBy: "",
      })
    );
  };

  const handleClickExcel = () => {
    const updatedSorting = reports?.sortBy;
    switch (currentShowingTable) {
      case "PurchasedCreditsMonthly":
        let PurchasedCreditsmonthlyExcelColumns = [
          "Date",
          "Date On Gateway",
          "Order Id",
          "Payment Transaction ID",
          "Payment Charge ID",
          "Name",
          "Name On Gateway",
          "Payment Type",
          "Amount ($)",
          "Payment Status",
          "Action",
        ];

        let purchasedMonthlyValue = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: 1,
          pageNo: 1,
          rowCountPerPage: tableTotalRecord, //Table
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          sortBy: updatedSorting.trim(),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            purchasedMonthlyValue
          )
        ).then((res) => {
          let result = res?.payload;
          const PurchasedCreditsMonthlyData = result?.DataList?.map((obj) => ({
            Date: obj?.TransactionDate,
            Date_On_Gateway: obj?.TransDate,
            Order_Id: obj?.POTransactionRandomID,
            Payment_Transaction_ID: obj?.PayPalTransactionID,
            Payment_Charge_ID: obj?.PaymentChargeID,
            Name: obj?.PublicUserName,
            Name_On_Gateway: obj?.TransactionName,
            Payment_Type: obj?.PaymentType,
            "Amount ($)": obj?.PurchaseAmount?.toFixed(2),
            Payment_Status: obj?.PaymentStatus,
            Action: "Confirmed",
          }));

          generateXlsx(
            PurchasedCreditsMonthlyData,
            PurchasedCreditsmonthlyExcelColumns,
            "Purchase Credits Report"
          );
        });

        break;
      case "PurchasedCreditsDaily":
        let generatePurchasedCreditsDailyExcelColumns = [
          "Date",
          "Date On Gateway",
          "Order Id",
          "Payment Transaction ID",
          "Payment Charge ID",
          "Name",
          "Name On Gateway",
          "Payment Type",
          "Amount ($)",
          "Payment Status",
          "Action",
        ];

        let purchasedDailyValue = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: 1,
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          sortBy: updatedSorting.trim(),
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            purchasedDailyValue
          )
        ).then((res) => {
          let result = res?.payload;
          const PurchasedCreditsDailyData = result?.DataList?.map((obj) => ({
            Date: obj?.TransactionDate,
            Date_On_Gateway: obj?.TransDate,
            Order_Id: obj?.POTransactionRandomID,
            Payment_Transaction_ID: obj?.PayPalTransactionID,
            Payment_Charge_ID: obj?.PaymentChargeID,
            Name: obj?.PublicUserName,
            Name_On_Gateway: obj?.TransactionName,
            Payment_Type: obj?.PaymentType,
            "Amount ($)": obj?.PurchaseAmount?.toFixed(2),
            Payment_Status: obj?.PaymentStatus,
            Action: "Confirmed",
          }));

          generateXlsx(
            PurchasedCreditsDailyData,
            generatePurchasedCreditsDailyExcelColumns,
            "Purchase Credits Report"
          );
        });

        break;
      case "FailedTransactionsMonthly":
        let FailedTransactionsMonthlyExcelColumns = [
          "Date",
          "Date On Gateway",
          "Order Id",
          "Payment Transaction ID",
          "Payment Charge ID",
          "Name",
          "Name On Gateway",
          "Payment Type",
          "Amount ($)",
          "Payment Status",
        ];
        let FailedTransactionsMonthlyTrans = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: -1,
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          sortBy: updatedSorting.trim(),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            FailedTransactionsMonthlyTrans
          )
        ).then((res) => {
          let result = res?.payload;
          const failedTransMonthlyData = result?.DataList?.map((obj) => ({
            Date: obj?.TransactionDate,
            Date_On_Gateway: obj?.TransDate,
            Order_Id: obj?.POTransactionRandomID,
            Payment_Transaction_ID: obj?.PayPalTransactionID,
            Payment_Charge_ID: obj?.PaymentChargeID,
            Name: obj?.PublicUserName,
            Name_On_Gateway: obj?.TransactionName,
            Payment_Type: obj?.PaymentType,
            "Amount ($)": obj?.PurchaseAmount?.toFixed(2),
            Payment_Status: obj?.PaymentStatus,
          }));

          generateXlsx(
            failedTransMonthlyData,
            FailedTransactionsMonthlyExcelColumns,
            "Failed Transactions Report"
          );
        });
        break;
      case "FailedTransactionsDaily":
        let FailedDailyExcelColumns = [
          "Date",
          "Date On Gateway",
          "Order Id",
          "Payment Transaction ID",
          "Payment Charge ID",
          "Name",
          "Name On Gateway",
          "Payment Type",
          "Amount ($)",
          "Payment Status",
        ];
        let faileddailyTrans = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: -1,
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          sortBy: updatedSorting.trim(),
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            faileddailyTrans
          )
        ).then((res) => {
          let result = res?.payload;

          const FailedTransactionsData = result?.DataList?.map((obj) => ({
            Date: obj?.TransactionDate,
            Date_On_Gateway: obj?.TransDate,
            Order_Id: obj?.POTransactionRandomID,
            Payment_Transaction_ID: obj?.PayPalTransactionID,
            Payment_Charge_ID: obj?.PaymentChargeID,
            Name: obj?.PublicUserName,
            Name_On_Gateway: obj?.TransactionName,
            Payment_Type: obj?.PaymentType,
            "Amount ($)": obj?.PurchaseAmount?.toFixed(2),
            Payment_Status: obj?.PaymentStatus,
          }));
          generateXlsx(
            FailedTransactionsData,
            FailedDailyExcelColumns,
            "Failed Transactions Report"
          );
        });

        break;
      case "PendingTransactionsMonthly":
        let PendingTransactionsMonthlyExcelColumns = [
          "Date",
          "Date On Gateway",
          "Order Id",
          "Payment Transaction ID",
          "Payment Charge ID",
          "Name",
          "Name On Gateway",
          "Payment Type",
          "Amount ($)",
          "Payment Status",
        ];

        let pendingmonthlytrans = {
          facilityID: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          transactionSucess: 0,
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
          sortBy: updatedSorting.trim(),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyPurchaseOrderTransactionList(
            pendingmonthlytrans
          )
        ).then((res) => {
          let result = res?.payload;

          const PendingTransactionsMonthlyData = result?.DataList?.map(
            (obj) => ({
              Date: obj?.TransactionDate,
              Date_On_Gateway: obj?.TransDate,
              Order_Id: obj?.POTransactionRandomID,
              Payment_Transaction_ID: obj?.PayPalTransactionID,
              Payment_Charge_ID: obj?.PaymentChargeID,
              Name: obj?.PublicUserName,
              Name_On_Gateway: obj?.TransactionName,
              Payment_Type: obj?.PaymentType,
              "Amount ($)": obj?.PurchaseAmount?.toFixed(2),
              Payment_Status: obj?.PaymentStatus,
            })
          );
          generateXlsx(
            PendingTransactionsMonthlyData,
            PendingTransactionsMonthlyExcelColumns,
            "Pending Transactions Report"
          );
        });
        break;
      case "PendingTransactionsDaily":
        let PendingTransactionsDailyExcelColumns = [
          "Date",
          "Date On Gateway",
          "Order Id",
          "Payment Transaction ID",
          "Payment Charge ID",
          "Name",
          "Name On Gateway",
          "Payment Type",
          "Amount ($)",
          "Payment Status",
        ];
        let pendingDailytrans = {
          facilityId: reports?.facilityId,
          paymentType:
            reports?.paymentType === "ALL" ? "" : reports?.paymentType,
          dobEndDate: fDate(reports?.dobEndDate),
          transactionSucess: 0,
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          sortBy: updatedSorting.trim(),
        };
        dispatch(
          revenueReportingActions.LoadDailyPurchaseOrderTransactionList(
            pendingDailytrans
          )
        ).then((res) => {
          let result = res?.payload;

          const PendingTransactionsDailyData = result?.DataList?.map((obj) => ({
            Date: obj?.TransactionDate,
            Date_On_Gateway: obj?.TransDate,
            Order_Id: obj?.POTransactionRandomID,
            Payment_Transaction_ID: obj?.PayPalTransactionID,
            Payment_Charge_ID: obj?.PaymentChargeID,
            Name: obj?.PublicUserName,
            Name_On_Gateway: obj?.TransactionName,
            Payment_Type: obj?.PaymentType,
            "Amount ($)": obj?.PurchaseAmount?.toFixed(2),
            Payment_Status: obj?.PaymentStatus,
          }));
          generateXlsx(
            PendingTransactionsDailyData,
            PendingTransactionsDailyExcelColumns,
            "Pending Transactions Report"
          );
        });
        break;
      case "FreeCreditsMonthly":
        let freeCreditsmonthlyExcelColumns = [
          "Date",
          "Amount ($)",
          "Inmate ID",
          "Inmate Name",
          "Facility Code",
        ];
        let freeCreditmonthlytrans = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyFreeCreditsList(
            freeCreditmonthlytrans
          )
        ).then((res) => {
          let result = res?.payload;

          const freeCreditsMonthlyData = result?.DataList?.map((obj) => ({
            Date: obj?.InmateFreeCreditDate,
            "Amount ($)": obj.InmateFreeCreditAmount?.toFixed(2),
            Inmate_ID: obj?.InmateResidentId,
            Inmate_Name: obj?.InmateName,
            Facility_Code: obj?.FacilityCode,
          }));
          generateXlsx(
            freeCreditsMonthlyData,
            freeCreditsmonthlyExcelColumns,
            "Free Credits Report"
          );
        });
        break;
      case "FreeCreditsDaily":
        let freeCreditsDailyExcelColumns = [
          "Date",
          "Amount ($)",
          "Inmate ID",
          "Inmate Name",
          "Facility Code",
        ];
        let freecreditDailytrans = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
        };
        dispatch(
          revenueReportingActions.LoadDailyFreeCreditsList(freecreditDailytrans)
        ).then((res) => {
          let result = res?.payload;
          const freeCreditsData = result?.DataList?.map((obj) => ({
            Date: obj?.InmateFreeCreditDate,
            "Amount ($)": obj.InmateFreeCreditAmount?.toFixed(2),
            Inmate_ID: obj?.InmateResidentId,
            Inmate_Name: obj?.InmateName,
            Facility_Code: obj?.FacilityCode,
          }));
          generateXlsx(
            freeCreditsData,
            freeCreditsDailyExcelColumns,
            "Free Credits Report"
          );
        });
        break;
      case "CactasCreditsMonthly":
        let CactasCreditsMonthlyExcelColumns = [
          "Task No",
          "Date",
          "Inmate ID",
          "	Inmate Last Name",
          "Inmate First Name",
          "Facility Code",
          "Amount ($)",
        ];

        let CactasCreditsmonthly = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyCactasCreditsList(
            CactasCreditsmonthly
          )
        ).then((res) => {
          let result = res?.payload;
          // setFacilityData(result);

          const CactasCreditsMonthlyData = result?.DataList?.map((obj) => ({
            Task_No: obj?.TaskNo,
            Date: obj?.CactasTransactionDate,
            Inmate_ID: obj?.InmateResidentId,
            Inmate_Last_Name: obj?.LastName,
            Inmate_First_Name: obj?.FirstName,
            Facility_Code: obj?.FacilityCode,
            "Amount ($)": obj.Amount?.toFixed(2),
          }));
          generateXlsx(
            CactasCreditsMonthlyData,
            CactasCreditsMonthlyExcelColumns,
            "Cactas Revenue Report"
          );
        });
        break;
      case "CactasCreditsDaily":
        let CactasCreditsDailyExcelColumns = [
          "Task No",
          "Date",
          "Inmate ID",
          "	Inmate Last Name",
          "Inmate First Name",
          "Facility Code",
          "Amount ($)",
        ];
        let cactasCreditsDaily = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
        };
        dispatch(
          revenueReportingActions.LoadDailyCactasCreditsList(cactasCreditsDaily)
        ).then((res) => {
          let result = res?.payload;
          const CactasCreditsDailyData = result?.DataList?.map((obj) => ({
            Task_No: obj?.TaskNo,
            Date: obj?.CactasTransactionDate,
            Inmate_ID: obj?.InmateResidentId,
            Inmate_Last_Name: obj?.LastName,
            Inmate_First_Name: obj?.FirstName,
            Facility_Code: obj?.FacilityCode,
            "Amount ($)": obj.Amount?.toFixed(2),
          }));
          generateXlsx(
            CactasCreditsDailyData,
            CactasCreditsDailyExcelColumns,
            "Cactas Revenue Report"
          );
        });
        break;
      case "CactasRefund":
        let CactasRefundExcelColumns = [
          "Facility Code",
          "Inmate ID",
          "	Inmate Name",
          "Transaction Type",
          "Task No",
          "Refund Task No",
          "Task GUID",
          "Refund Task GUID",
          "Amount ($)",
          "Task Date",
          "Refund Date",
        ];
        let cactasRefund = {
          facilityID: reports?.facilityId,
          inmateResidentID: "",
          firstName: "",
          lastName: "",
          taskNo: 0,
          refundTaskNo: 0,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };

        dispatch(
          revenueReportingActions.LoadDicrepancyCactasRefundDetailsList(
            cactasRefund
          )
        ).then((res) => {
          let result = res?.payload;
          const CactasRefundData = result?.DataList?.map((obj) => ({
            Facility_Code: obj?.FacilityCode,
            Inmate_ID: obj?.ResidentId,
            Inmate_Name: obj?.InmateFullName,
            Transaction_Type: obj?.TransactionType,
            Task_No: obj?.TaskNo,
            Refund_Task_No: obj?.RefundTaskNo,
            Task_GUID: obj?.TaskGUID,
            Refund_Task_GUID: obj?.RefundTaskGUID,
            "Amount ($)": obj.Amount?.toFixed(2),
            Task_Date: formatDateTime(obj?.TaskDate),
            Refund_Date: formatDateTime(obj?.RefundedDate),
          }));
          generateXlsx(
            CactasRefundData,
            CactasRefundExcelColumns,
            "Cactas Discrepancy Report"
          );
        });
        break;

      default:
        break;
    }
  };

  const handleClickPDF = () => {
    const updatedSorting = reports?.sortBy;
    let title = "Cactas_Report";
    switch (currentShowingTable) {
      case "CactasCreditsMonthly":
        let CactasCreditsmonthly = {
          facilityID: reports?.facilityId,
          month: reports?.actions === 3 ? 0 : reports?.month,
          year: reports?.actions === 3 ? 0 : reports?.year,
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
          fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
          toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        };
        dispatch(
          revenueReportingActions.LoadMonthlyCactasCreditsList(
            CactasCreditsmonthly
          )
        ).then((res) => {
          let result = res?.payload;
          const CactasCreditsData = result?.DataList?.map((obj) => ({
            "Task No": obj?.TaskNo,
            Date: formatDateTime(obj?.CactasTransactionDate),
            "Inmate ID": obj?.InmateResidentId,
            "Inmate Last Name": obj?.LastName,
            "Inmate First Name": obj?.FirstName,
            "Facility Code": obj?.FacilityCode,
            "Amount ($)": obj.Amount?.toFixed(2),
            "Transaction Type":
              parseInt(obj?.CreditAmount) > 0 ? "Refund" : "Debit",
          }));

          const prepareTableData = (dataArray) => {
            if (dataArray.length === 0) return { headers: [], rows: [] };

            // Extract headers from the keys of the first object
            const headers = Object.keys(dataArray[0]);

            // Extract rows from the values of each object
            const rows = dataArray.map((item) => Object.values(item));

            return { headers, rows };
          };

          // Prepare data for the PDF table
          const { headers, rows } = prepareTableData(CactasCreditsData);

          // Generate PDF
          generatePDFForVerticalTable(headers, rows, true, "Cactas Report");
        });

        break;
      case "CactasCreditsDaily":
        // let cactasCreditsDaily = {
        //   facilityID: reports?.facilityId,
        //   month: reports?.actions === 3 ? 0 : reports?.month,
        //   year: reports?.actions === 3 ? 0 : reports?.year,
        //   sortBy: "",
        //   pageNo: 1,
        //   rowCountPerPage: tableTotalRecord,
        //   fromDate: reports?.actions === 2 ? "" : fDate(reports?.fromDate),
        //   toDate: reports?.actions === 2 ? "" : fDate(reports?.toDate),
        // };
        let cactasCreditsDaily = {
          facilityId: reports?.facilityId,
          selectDate: fDate(reports?.dobEndDate),
          sortBy: updatedSorting.trim(),
          pageNo: 1,
          rowCountPerPage: tableTotalRecord,
        };
        dispatch(
          revenueReportingActions.LoadDailyCactasCreditsList(cactasCreditsDaily)
        ).then((res) => {
          let result = res?.payload;
          const CactasCreditsDailyData = result?.DataList?.map((obj) => ({
            Task_No: obj?.TaskNo,
            Date: obj?.CactasTransactionDate,
            Inmate_ID: obj?.InmateResidentId,
            Inmate_Last_Name: obj?.LastName,
            Inmate_First_Name: obj?.FirstName,
            Facility_Code: obj?.FacilityCode,
            "Amount ($)": obj.Amount?.toFixed(2),
          }));

          const prepareTableData = (dataArray) => {
            if (dataArray.length === 0) return { headers: [], rows: [] };

            // Extract headers from the keys of the first object
            const headers = Object.keys(dataArray[0]);

            // Extract rows from the values of each object
            const rows = dataArray.map((item) => Object.values(item));

            return { headers, rows };
          };

          const { headers, rows } = prepareTableData(CactasCreditsDailyData);

          generatePDFForVerticalTable(headers, rows, true, "Cactas Report");
        });

        break;

      default:
        break;
    }
  };

  const handleNavigatePublicUserPayment = (row) => {
    history.navigate("PublicUserList/Details", {
      state: {
        row: row,
        source: "RevenueReport",
        backTo: "RevenueReport",
        currentShowingTable: currentShowingTable,
      },
    });
    // change facility code for the consent user
    dispatch(authActions?.updateCommonFacilityCode(row?.FacilityID));

    dispatch(publicUserActions.setPublicUserTab("publicuser-payments-tab"));
  };
  if (loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const toggleCactasInformation = () => {
    setShowCactasSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row col-lg-12">
          <div className={"mb-3 col-lg-4"}>
            <RadioInput
              name="records"
              id="records"
              label="Records"
              selectedValue={reports?.records}
              handleChange={(e) => handleChange(e, "records")}
              options={records}
            />
          </div>
          {reports?.records === 2 && (
            <div className="mb-3 col-lg-4">
              <SelectInput
                name="facilityId"
                label="Facility Code"
                options={facilitydata}
                value={reports?.facilityId}
                required={true}
                handleChange={(e) => handleSelectChange(e, "facilityId")}
                isClearable={reports?.facilityId !== 0}
                placeholder=""
                errorMessage={errorMessage}
                // handleBlur={() =>
                //   handleOnBlur({ target: { name: "facilityId" } })
                // }
                menuPortalTarget={document.body}
                menuPosition="absolute" // More iOS-friendly than "fixed"
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                    position: "absolute", // Avoid "fixed" on iOS
                  }),
                }}
              />
            </div>
          )}

          <div
            className={`mb-3 ${reports?.records === 2 ? "col-lg-4" : "col-lg-8"
              }`}
          >
            <SelectInput
              name="paymentType"
              label="Payment Type"
              options={paymentTypeOption}
              value={reports?.paymentType}
              isMulti={false}
              closeMenuOnSelect={true}
              isDisabled={false}
              isLoading={false}
              handleChange={(e) => handleSelectChange(e, "paymentType")}
              isClearable={reports?.paymentType !== "ALL"}
              placeholder=""
            />
          </div>
        </div>
        <div className="row col-lg-12">
          <div className={`mb-3 col-lg-4`}>
            <RadioInput
              name="actions"
              id="actions"
              label="Action"
              selectedValue={reports?.actions}
              handleChange={(e) => handleChange(e, "actions")}
              options={actions}
            />
          </div>
          {reports.actions === 3 && (
            <>
              <div className="mb-3 col-lg -4">
                <DateInput
                  label="From Date"
                  name="fromDate"
                  value={reports?.fromDate}
                  required={true}
                  handleChange={(e) => handleChange(e, "fromDate")}
                  placeholderText="Select a date"
                  yearDropDown={true}
                  errorMessage={errorMessage}
                  // minDate={startDate} // You can define a specific start date, or this can be `new Date()` for today.
                  minDate={
                    reports?.toDate
                      ? new Date(new Date(reports.toDate).setFullYear(new Date(reports.toDate).getFullYear() - 1))
                      : startDate
                  }// You can define a specific start date, or this can be `new Date()` for today.

                  maxDate={reports?.toDate || new Date()} // From Date cannot be after To Date
                  isClearable={
                    reports?.fromDate !== null && reports?.fromDate !== ""
                  }
                  handleBlur={(e) => handleDateBlur(e, "fromDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "fromDate")}
                />
              </div>
              <div className="mb-3 col-lg -4">
                <DateInput
                  label="To Date"
                  name="toDate"
                  required={true}
                  value={reports?.toDate}
                  handleChange={(e) => handleChange(e, "toDate")}
                  placeholderText="Select a date"
                  yearDropDown={true}
                  maxDate={
                    reports?.fromDate !== ""
                      ? new Date(
                        Math.min(
                          new Date(reports?.fromDate).setFullYear(
                            new Date(reports?.fromDate).getFullYear() + 1
                          ), // 1 year after fromDate
                          new Date() // Current date
                        )
                      )
                      : new Date()
                  }
                  errorMessage={errorMessage}
                  minDate={reports?.fromDate ? reports?.fromDate : startDate} // To Date must be greater than or equal to From Date
                  isClearable={
                    reports?.toDate !== null && reports?.toDate !== ""
                  }
                  handleBlur={(e) => handleDateBlur(e, "toDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "toDate")}
                />
              </div>
            </>
          )}
          {reports?.actions === 1 && (
            <div className={"mb-3 col-lg-8"}>
              <DateInput
                label="Date"
                name="dobEndDate"
                required={true}
                value={reports?.dobEndDate}
                handleChange={(e) => handleChange(e, "dobEndDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                maxDate={new Date()}
                minDate={startDate}
                isClearable={
                  reports?.dobEndDate !== null && reports?.dobEndDate !== ""
                }
                errorMessage={errorMessage}
                handleBlur={handleOnBlur}
                handleKeyDown={(e) => handleDateEnterKey(e, "dobEndDate")}
              />
            </div>
          )}
          {reports?.actions === 2 && (
            <>
              <div className="mb-3 col-lg -4">
                <SelectInput
                  name="year"
                  label="Year"
                  options={yearOptions}
                  required={true}
                  value={reports?.year}
                  handleChange={(e) => handleSelectChange(e, "year")}
                  isClearable={reports?.year !== 0}
                  maxDate={new Date()}
                  errorMessage={errorMessage}
                  isSearchable={false}
                // handleBlur={() => handleOnBlur({ target: { name: "year" } })}
                // handleBlur={() =>
                //   handleOnBlur({
                //     target: { name: "year", value: reports?.year },
                //   })
                // }
                />
              </div>
              <div className="mb-3 col-lg -4">
                <SelectInput
                  name="month"
                  label="Month"
                  options={generateMonthOptions(reports?.year)}
                  required={!!reports.year}
                  value={reports?.month}
                  handleChange={(e) => handleSelectChange(e, "month")}
                  isClearable={reports?.month !== 0}
                  maxDate={new Date()}
                  isDisabled={!reports.year}
                  errorMessage={errorMessage}
                  isSearchable={false}
                // handleBlur={() => handleOnBlur({ target: { name: "month" } })}
                // handleBlur={() =>
                //   handleOnBlur({
                //     target: { name: "month", value: reports?.month },
                //   })
                // }
                />
              </div>
            </>
          )}
        </div>

        <div className="d-flex flex-wrap justify-content-center mt-4 gap-3">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            icon={"search"}
            variant="danger"
            status={"primary"}
            onClick={handleSearch}
            disabled={false}
          />
          <Button
            className="me-2"
            onClick={handleReset}
            label="Reset"
            type="reset"
            variant="danger"
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  const renderCactasSearch = () => {
    return (
      <div className="p-1 ">
        <div className="row">
          <div className="col-sm-12 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateResidentID"
                label="Inmate ID"
                value={reports?.inmateResidentID}
                handleChange={handleCactasChange}
                maxLength={18}
                placeholder="Enter Inmate ID"
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleCactusSearch(event);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="lastName"
                label="Inmate Last Name"
                value={reports?.lastNameValue}
                handleChange={(e) => handleStatusChange(e, "lastName")}
                options={inmateLN}
                isClearable={reports?.lastNameValue !== 0}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <SelectInput
                options={inmateFN}
                name="firstName"
                label="Inmate First Name"
                value={reports?.firstNameValue}
                handleChange={(e) => handleStatusChange(e, "firstName")}
                isClearable={reports?.firstNameValue !== 0}
              />
            </div>
          </div>

          <div className="col-sm-12 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <TextInput
                name="taskNo"
                label="Task No"
                value={reports?.taskNo !== 0 ? reports?.taskNo : ""}
                handleChange={handleCactasChange}
                maxLength={18}
                placeholder="Enter Task No"
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleCactusSearch(event);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <TextInput
                name="refundTaskNo"
                label="Refund Task No"
                value={reports?.refundTaskNo !== 0 ? reports?.refundTaskNo : ""}
                handleChange={handleCactasChange}
                maxLength={18}
                placeholder="Enter Refund Task No"
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleCactusSearch(event);
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            icon={"search"}
            variant="danger"
            status={"primary"}
            onClick={handleCactusSearch}
            disabled={false}
          />
          <Button
            className="me-2"
            onClick={handleCactusReset}
            label="Reset"
            type="reset"
            variant="danger"
            status={"secondary"}
            disabled={false}
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100">
        {/* <div className="mb-2 d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className="form_title_uppercase text-color">Reports Search</h2>
        </div> */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">Reports Search</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">Reports Search</h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>
      {!tableShow && Object.keys(revenueSummaryList).length > 0 && (
        <div className="card-body mobile-responsive">
          <div className="managementUser p-4  shadow-sm b-r-all border border-dark-grey mt-3 w-100 mb-4">
            <div className="form_title_uppercase text-color text-center mt-4">
              <h2>
                {reports.actions === 2
                  ? "Monthly Report"
                  : reports.actions === 3
                    ? "Periodic Report"
                    : "Daily Report"}
              </h2>
            </div>

            <>
              <table className="table table-bordered  table-striped fs-5">
                <tbody>
                  <tr>
                    <th
                      style={{ width: "30%" }}
                      className="Common_Link_Style"
                    //onClick={() => handleTableClick("PurchasedCredits")}
                    >
                      <span
                        onClick={() => handleTableClick("PurchasedCredits")}
                      >
                        Purchased Credits
                      </span>
                    </th>
                    <td className="width-400">
                      {reports?.paymentType === "ALL" &&
                        revenueSummaryList?.TotalPurchaseCreditSuccessAsDisplay}
                      $
                      {reports?.paymentType === "PAYPAL" &&
                        revenueSummaryList?.PaypalPurchaseCreditSuccess?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "STRIPE" &&
                        revenueSummaryList?.StripePurchaseCreditSuccess?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "IOSInAPP" &&
                        revenueSummaryList?.IOSInAppPurchaseCreditSuccess?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "Google" &&
                        revenueSummaryList?.GoogleePurchaseCreditSuccess?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "ALL" &&
                        revenueSummaryList?.TotalPurchaseCreditSuccess?.toFixed(
                          2
                        )}
                      <br></br>
                      {reports.paymentType === "ALL" && (
                        <span className="text-danger fw-bold">
                          (Paypal + Stripe + Google (Android + iOS + Web))
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{ width: "30%" }}
                      className="Common_Link_Style"
                    //onClick={() => handleTableClick("FailedTransactions")}
                    >
                      <span
                        onClick={() => handleTableClick("FailedTransactions")}
                      >
                        Failed Transactions
                      </span>
                    </th>
                    <td>
                      {reports?.paymentType === "ALL" &&
                        revenueSummaryList?.TotalPurchaseCreditFailedAsDisplay}
                      $
                      {reports?.paymentType === "PAYPAL" &&
                        revenueSummaryList?.PaypalPurchaseCreditFailed?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "STRIPE" &&
                        revenueSummaryList?.StripePurchaseCreditFailed?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "IOSInAPP" &&
                        revenueSummaryList?.IOSInAppPurchaseCreditFailed?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "Google" &&
                        revenueSummaryList?.GooglePurchaseCreditFailed?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "ALL" &&
                        revenueSummaryList?.TotalPurchaseCreditFailed?.toFixed(
                          2
                        )}
                      <br></br>
                      {reports.paymentType === "ALL" && (
                        <span className="text-danger fw-bold">
                          (Paypal + Stripe + Google (Android + iOS + Web))
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{ width: "300px" }}
                      className="Common_Link_Style"
                    //onClick={() => handleTableClick("PendingTransactions")}
                    >
                      <span
                        onClick={() => handleTableClick("PendingTransactions")}
                      >
                        Pending Transactions
                      </span>
                    </th>
                    <td>
                      {reports?.paymentType === "ALL" &&
                        revenueSummaryList?.TotalPurchaseCreditPendingAsDisplay}
                      $
                      {reports?.paymentType === "PAYPAL" &&
                        revenueSummaryList?.PaypalPurchaseCreditPending?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "STRIPE" &&
                        revenueSummaryList?.StripePurchaseCreditPending?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "IOSInAPP" &&
                        revenueSummaryList?.IOSInAppPurchaseCreditPending?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "Google" &&
                        revenueSummaryList?.GooglePurchaseCreditPending?.toFixed(
                          2
                        )}
                      {reports?.paymentType === "ALL" &&
                        revenueSummaryList?.TotalPurchaseCreditPending?.toFixed(
                          2
                        )}
                      <br></br>
                      {reports.paymentType === "ALL" && (
                        <span className="text-danger fw-bold">
                          (Paypal + Stripe + Google (Android + iOS + Web))
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{ width: "30%" }}
                      className="Common_Link_Style"
                    //onClick={() => handleTableClick("FreeCredits")}
                    >
                      <span onClick={() => handleTableClick("FreeCredits")}>
                        Free Credits
                      </span>
                    </th>
                    <td>
                      ${revenueSummaryList?.TotalInmateFreeCredit?.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{ width: "30%" }}
                      className="Common_Link_Style"
                    //onClick={() => handleTableClick("CactasCredits")}
                    >
                      <span onClick={() => handleTableClick("CactasCredits")}>
                        Cactas Credits
                      </span>
                    </th>
                    <td>
                      $(
                      {revenueSummaryList?.TotalInmateCactasCreditAmountAll?.toFixed(
                        2
                      )}
                      -
                      {revenueSummaryList?.TotalInmateCactasCreditAmountRefund?.toFixed(
                        2
                      )}
                      )=$
                      {revenueSummaryList?.TotalInmateCactasCreditAmount?.toFixed(
                        2
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th style={{ width: "30%" }}>Refund</th>
                    <td>
                      $
                      {(
                        revenueSummaryList?.TotalMessageRefundAmt +
                        revenueSummaryList?.TotalPhotoRefundAmt
                      )?.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{ width: "30%" }}
                      className="Common_Link_Style"
                    //onClick={() => handleTableClick("CactasRefund")}
                    >
                      <span onClick={() => handleTableClick("CactasRefund")}>
                        Cactas Refund
                      </span>
                    </th>
                    <td>
                      ${revenueSummaryList?.TotalCactasAmountRefund?.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: "30%" }}>Total Received</th>
                    <td>
                      $
                      {(
                        revenueSummaryList?.TotalMessageSentCost +
                        revenueSummaryList?.TotalMessageOldApprovedAmt +
                        revenueSummaryList?.TotalPhotoAmt +
                        revenueSummaryList?.TotalECardAmt
                      )?.toFixed(2)}
                    </td>
                  </tr>
                  <tr className="fs-5">
                    <th style={{ width: "30%" }}>Total Sale Received</th>
                    <td>
                      {revenueSummaryList?.TotalAsDisplay}$
                      {revenueSummaryList?.TotalSaleReceived?.toFixed(2)}
                      <br></br>
                      <span className=" text-danger fw-bold">
                        ((CM + CCM + PH + EC + OCCM) - MSG REFUND - PH REFUND)
                      </span>
                      <div className="d-flex flex-wrap flex-column align-items-end  text-danger fw-bold">
                        <div>
                          CM :
                          <label className="fw-normal">Credit Messages</label>
                        </div>
                        <div>
                          CCM :
                          <label className="fw-normal">
                            Cactas Credit Messages
                          </label>
                        </div>
                        <div>
                          PH :<label className="fw-normal">Photos</label>
                        </div>
                        <div>
                          EC :<label className="fw-normal">E-Cards</label>
                        </div>
                        <div>
                          OCCM :
                          <label className="fw-normal">
                            Old Cactas credit Messages
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* <div className=" d-flex mobile-grid-responsive  justify-content-center mt-4 gap-4"> */}
              <br />
              <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100">
                <div className="form_title_uppercase text-color">
                  <h2>Messages:</h2>
                </div>
                <table className="me-2 table table-bordered table-striped mobile-grid-width fs-5">
                  <tbody>
                    <tr style={{ height: "30px" }}>
                      <th>Messages</th>
                      <td>{revenueSummaryList?.TotalMessageSent}</td>
                      <td>
                        $
                        {`(${(
                          (parseFloat(
                            revenueSummaryList?.TotalMessageSentCost
                          ) || 0) -
                          (parseFloat(
                            revenueSummaryList?.TotalMessageEmojiCost
                          ) || 0)
                        ).toFixed(
                          2
                        )} + ${revenueSummaryList?.TotalMessageEmojiCost?.toFixed(
                          2
                        )}) = $${revenueSummaryList?.TotalMessageSentCost?.toFixed(
                          2
                        )}`}
                        <br></br>
                        <span className=" text-danger fw-bold">
                          (Messages Cost + Emojis Cost) = Total Messages Cost
                        </span>
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Credit Messages</th>
                      <td>{revenueSummaryList?.TotalCreditMessageCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCreditMessageCost?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Free Credit Messages</th>
                      <td>{revenueSummaryList?.TotalFreeCreditMsgCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalFreeCreditMsgCost?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Cactas Credit Messages</th>
                      <td>{revenueSummaryList?.TotalCactasMessageCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCactasMessageCost?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Total Approved</th>
                      <td>{revenueSummaryList?.TotalMessageApprovedCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalMessageApprovedAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Pending Approval</th>
                      <td>
                        {revenueSummaryList?.TotalMessageNotApprovedCount}
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalMessageNotApprovedAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Delivered</th>
                      <td>
                        {revenueSummaryList?.TotalNoCODMessageApprovedCount}
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalNoCODMessageApprovedAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>COD Approved</th>
                      <td>
                        {revenueSummaryList?.TotalCODMessageApprovedCount}
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCODMessageApprovedAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>COD Approval Pending</th>
                      <td>{revenueSummaryList?.TotalCODMessagePendingCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCODMessagePendingAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    {/* <tr style={{ height: "30px" }}>
                      <th>COD Rejected</th>
                      <td>{revenueSummaryList?.TotalCODRejectedMessageCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCODRejectedMessageAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr> */}
                    <tr style={{ height: "30px" }}>
                      <th>COD Rejected</th>
                      <td>{revenueSummaryList?.TotalCODRejectedMessageCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCODRejectedMessageAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Total COD</th>
                      <td>{revenueSummaryList?.TotalCODPendingCount}</td>
                      <td>
                        -${revenueSummaryList?.TotalCODPendingCost?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>
                        COD Delivered <br></br>(From Prev. Month)
                      </th>
                      <td>
                        {revenueSummaryList?.TotalMessageOldApprovedCount}
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalMessageOldApprovedAmt?.toFixed(
                          2
                        )}
                        <br></br>
                        <span className=" text-danger fw-bold">
                          (CR -{" "}
                          {revenueSummaryList?.TotalMessageOldApprovedCreditAmt?.toFixed(
                            2
                          )}{" "}
                          + FR -{" "}
                          {revenueSummaryList?.TotalMessageOldApprovedFreeAmt?.toFixed(
                            2
                          )}{" "}
                          + CA -{" "}
                          {revenueSummaryList?.TotalMessageOldApprovedCactasAmt?.toFixed(
                            2
                          )}{" "}
                          )
                        </span>
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Refund</th>
                      <td>{revenueSummaryList?.TotalMessageRefundCount}</td>
                      <td>
                        -$
                        {revenueSummaryList?.TotalMessageRefundAmt?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Total :</th>
                      <td>
                        {revenueSummaryList?.TotalMessageSent +
                          revenueSummaryList?.TotalMessageOldApprovedCount}
                      </td>
                      <td>
                        $
                        {(
                          revenueSummaryList?.TotalMessageSentCost +
                          revenueSummaryList?.TotalMessageOldApprovedAmt
                        )?.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100">
                <h2>Photos:</h2>
                <table className="me-2 table table-bordered table-striped mobile-grid-width fs-5">
                  <tbody>
                    <tr style={{ height: "30px" }}>
                      <th>Photos</th>
                      <td>{revenueSummaryList?.TotalPhotoCount}</td>
                      <td>
                        {`$(${photoCost?.toFixed(
                          2
                        )} + ${revenueSummaryList?.TotalPhotoEmojiCost?.toFixed(
                          2
                        )}) = $${revenueSummaryList?.TotalPhotoAmt?.toFixed(
                          2
                        )}`}
                        <br></br>
                        <span className=" text-danger fw-bold">
                          (Photos Cost + Emojis Cost) = Total Photos Cost
                        </span>
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Credit Photos</th>
                      <td>{revenueSummaryList?.TotalPhotoCreditCount}</td>
                      <td>
                        ${revenueSummaryList?.TotalPhotoCreditAmt?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Total Approved</th>
                      <td>
                        {revenueSummaryList?.TotalNoCODApprovedPhotoCount}
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalNoCODApprovedPhotoAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Pending Approval</th>
                      <td>
                        {
                          revenueSummaryList?.TotalNoCODPendingApprovalPhotoCount
                        }
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalNoCODPendingApprovalPhotoAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Rejected</th>
                      <td>{revenueSummaryList?.TotalRejectedPhotoCount}</td>
                      <td>
                        ${revenueSummaryList?.TotalRejectedPhotoAmt?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Delivered</th>
                      <td>
                        {revenueSummaryList?.TotalNoCODDeliveredPhotoCount}
                      </td>
                      <td>
                        $
                        {revenueSummaryList?.TotalNoCODDeliveredPhotoAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Refund</th>
                      <td>{revenueSummaryList?.TotalPhotoRefundCount}</td>
                      <td>
                        -${revenueSummaryList?.TotalPhotoRefundAmt?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Total :</th>
                      <td>{revenueSummaryList?.TotalPhotoCount}</td>
                      <td> ${revenueSummaryList?.TotalPhotoAmt?.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100">
                <div className="form_title_uppercase text-color">
                  <h2>E-Cards:</h2>
                </div>
                <table className="me-2 table table-bordered table-striped mobile-grid-width fs-5">
                  <tbody>
                    <tr style={{ height: "30px" }}>
                      <th>E-Cards</th>
                      <td>{revenueSummaryList?.TotalECardCount}</td>
                      <td>
                        {`$(${eCardCost?.toFixed(
                          2
                        )} + ${revenueSummaryList?.TotalECardEmojiCost?.toFixed(
                          2
                        )}) = $${revenueSummaryList?.TotalECardAmt?.toFixed(
                          2
                        )}`}
                        <br></br>
                        <span className=" text-danger fw-bold">
                          (E-Cards Cost + Emojis Cost) = Total E-Cards Cost
                        </span>
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Credit E-Cards</th>
                      <td>{revenueSummaryList?.TotalECardCreditCount}</td>
                      <td>
                        ${revenueSummaryList?.TotalECardCreditAmt?.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Free Credit E-Cards</th>
                      <td>{revenueSummaryList?.TotalFreeCreditECardCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalFreeCreditECardAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Cactas Credit E-Cards</th>
                      <td>{revenueSummaryList?.TotalCactasCreditECardCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalCactasCreditECardAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Delivered</th>
                      <td>{revenueSummaryList?.TotalDeliveredECardCount}</td>
                      <td>
                        $
                        {revenueSummaryList?.TotalDeliveredECardCreditAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Refund</th>
                      <td>{revenueSummaryList?.TotalRefundECardCount}</td>
                      <td>
                        -$
                        {revenueSummaryList?.TotalRefundECardCreditAmt?.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr style={{ height: "30px" }}>
                      <th>Total :</th>
                      <td>{revenueSummaryList?.TotalECardCount}</td>
                      <td> ${revenueSummaryList?.TotalECardAmt?.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* </div> */}
            </>
          </div>
        </div>
      )}
      {currentShowingTable === "CactasRefund" && (
        <div className=" border-dark-grey mt-2">
          <div className="form_title_uppercase text-color text-center mt-4">
            <h2>
              {reports.actions === 2
                ? "Monthly Report"
                : reports.actions === 3
                  ? "Periodic Report"
                  : "Daily Report"}
            </h2>
          </div>
          <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100 ">
            {/* <h4 className="form_title_uppercase text-color">
              Cactas Discrepancy Search
            </h4> */}
            {/* Mobile only (Below md breakpoint) */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleCactasInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  Cactas Discrepancy Search
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showCactasSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none">
              {showCactasSearchFields && renderCactasSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                Cactas Discrepancy Search
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderCactasSearch()}</div>
          </div>
        </div>
      )}

      {(tableShow && currentShowingTable?.trim()?.length != 0) && (
        <>
          <div className="">
            <RevenueReportTable
              title={tableTitle}
              columns={tableColumn}
              data={tableData}
              totalRowCount={tableTotalRecord}
              pagination={true}
              paginationPerPage={reports?.rowCountPerPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={RowsCountPerPage}
              currentPage={reports?.pageNo}
              handleClickExcel={handleClickExcel}
              handleClickPDF={handleClickPDF}
              setCurrentShowingTable={setCurrentShowingTable}
              setTableShow={setTableShow}
              setReports={revenueReportingActions.setReports}
              handleSearch={handleSearch}
              handleSort={handleSort}
              sortingColumn={reports?.sortBy.split(" ")[0]}
              sortingDirection={reports?.sortBy.split(" ")[1]}
            />
          </div>
          <CommonModal
            modalId="revenue-orderId-modal"
            title="PAYMENT DETAILS"
            loader={userPaymentInfo?.loading}
            bodyContent={
              <div className="card-body mobile-responsive">
                <table className="table table-bordered table-striped fs-5">
                  <tbody>
                    <tr>
                      <th>Order ID</th>
                      <td
                        className="Common_Link_Style"
                        data-bs-dismiss="modal" //// to hide popup
                        onClick={() =>
                          handleNavigatePublicUserPayment(userPaymentInfo)
                        }
                      >
                        {userPaymentInfo?.POTransactionRandomID}
                      </td>
                    </tr>
                    <tr>
                      <th>Payment Transaction ID</th>
                      <td>
                        {userPaymentInfo?.PaymentTransactionID
                          ? userPaymentInfo?.PaymentTransactionID
                          : "---"}
                      </td>
                    </tr>
                    <tr>
                      <th>Payment Charge ID</th>
                      <td>{userPaymentInfo?.PaymentChargeID}</td>
                    </tr>
                    <tr>
                      <th>Transfer Date</th>
                      <td>{userPaymentInfo?.CreatedDate}</td>
                    </tr>
                    <tr>
                      <th>Payment Type</th>
                      <td>{userPaymentInfo?.PaymentType}</td>
                      <tr></tr>
                      <th>Payment Status</th>
                      <td>{userPaymentInfo?.PaymentStatus}</td>
                    </tr>
                    <tr>
                      <th>Seller Message</th>
                      <td>{userPaymentInfo?.PaySellerMessage || "---"}</td>
                    </tr>
                    <tr>
                      <th colSpan="2" style={{ color: "#CC5A5A" }}>
                        INMATE DETAILS
                      </th>
                    </tr>
                    <tr>
                      <th>Resident ID</th>
                      <td>{userPaymentInfo?.InmateID}</td>
                    </tr>
                    <tr>
                      <th>Facility Code</th>
                      <td>{userPaymentInfo?.FacilityCode}</td>
                    </tr>
                    <tr>
                      <th>Last Name</th>
                      <td>{userPaymentInfo?.InmateLastName}</td>
                    </tr>
                    <tr>
                      <th>First Name</th>
                      <td>{userPaymentInfo?.InmateFirstName}</td>
                    </tr>
                    <tr>
                      <th colSpan="2" style={{ color: "#CC5A5A" }}>
                        PUBLIC USER DETAILS
                      </th>
                    </tr>
                    <tr>
                      <th>Last Name</th>
                      <td>{userPaymentInfo?.PublicUserLastName}</td>
                    </tr>
                    <tr>
                      <th>First Name</th>
                      <td>{userPaymentInfo?.PublicUserFirstName}</td>
                    </tr>
                    <tr>
                      <th>Purchased Credits</th>
                      <td>{`$${(userPaymentInfo?.PurchaseAmount || 0).toFixed(
                        2
                      )}`}</td>
                    </tr>
                    <tr>
                      <th>Available Credits</th>
                      <td>{`$${(userPaymentInfo?.CreditBalance || 0).toFixed(
                        2
                      )}`}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            }
            footerContent={
              <button className="btn button-primary" data-bs-dismiss="modal">
                Close
              </button>
            }
          />
        </>
      )}
    </div>
  );
}

export default React.memo(RevenueReport);
